(function () {
  'use strict';

  window.JJ_API_BASE = window.JJ_API_BASE || 'https://jj-intelligence-engine.vercel.app/api';

  function byId(id) {
    return document.getElementById(id);
  }

  function jjEscapeHtml(str) {
    return String(str || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  const body = document.body;
  const client = window.JJ_CLIENT || {};
  const JJ_PRIVATE_DESK_APPLICATION_URL = '/pages/private-access';
  let jjSignalAnchorId = null;
  let jjSignalBuildCount = 0;
  let jjCurrentSignalLook = null;
  const jjRecentSignalSlots = {};

  /* ===============================
     MEMBERSHIP ACCESS
  ================================ */

  const membershipTier = client.membershipTier
    ? client.membershipTier.replace('jj_', '').trim().toLowerCase()
    : null;

  const access = {
    preview: {
      canMessage: false,
      canGarmentCare: false,
      canBook: false,
      canSaveCloset: false,
      canProfile: false
    },
    edit: {
      canMessage: true,
      canGarmentCare: true,
      canBook: true,
      canSaveCloset: true,
      canProfile: true
    },
    advisory: {
      canMessage: true,
      canGarmentCare: true,
      canBook: true,
      canSaveCloset: true,
      canProfile: true,
      priority: true
    }
  };

  const userAccess = (membershipTier && access[membershipTier]) || access.preview;

  function jjHasPrivateDeskMembership() {
    const tier = client.membershipTier
      ? client.membershipTier.replace('jj_', '').trim().toLowerCase()
      : null;
    const status = client.membershipStatus
      ? String(client.membershipStatus).trim().toLowerCase()
      : null;

    if (!tier || tier === 'none' || tier === 'preview') return false;
    if (status && ['inactive', 'cancelled', 'canceled', 'expired', 'none'].includes(status)) return false;
    return ['edit', 'advisory'].includes(tier);
  }

  function blockSection(selector) {
    const el = document.querySelector(selector);
    if (!el) return;

    el.style.position = 'relative';
    el.style.filter = 'none';
    el.style.opacity = '1';
    el.style.pointerEvents = 'auto';
    el.classList.add('jj-is-soft-locked');

    if (el.querySelector('.jj-soft-lock')) return;

    const overlay = document.createElement('div');
    overlay.className = 'jj-soft-lock';
    overlay.innerHTML = `
      <div class="jj-soft-lock-card">
        <p class="jj-soft-lock-title">Upgrade Access</p>
        <p class="jj-soft-lock-sub">Closet System is available to Private Desk Subscribers and Advisory Clients</p>
        <button class="jj-soft-lock-btn" type="button">Apply For Access</button>
      </div>
    `;

    el.appendChild(overlay);

    const button = overlay.querySelector('button');
    if (button) {
      button.addEventListener('click', function () {
        window.location.href = JJ_PRIVATE_DESK_APPLICATION_URL;
      });
    }
  }

  function gateSection(selector, requiredTier) {
    const tier = client.membershipTier
      ? client.membershipTier.replace('jj_', '').trim().toLowerCase()
      : null;

    const tierRank = {
      preview: 1,
      edit: 2,
      advisory: 3
    };

    if (!tier || tier === 'none') {
      blockSection(selector);
      return;
    }

    if (!tierRank[tier] || tierRank[tier] < tierRank[requiredTier]) {
      blockSection(selector);
    }
  }

  if (membershipTier === 'advisory') {
    document.body.classList.add('jj-advisory');
  }

  /* ===============================
     REVEAL
  ================================ */

  function initRevealAnimation() {
    const els = document.querySelectorAll('.jj-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    Array.prototype.forEach.call(els, function (el) {
      io.observe(el);
    });
  }

  /* ===============================
     MODALS
  ================================ */

  function openModal(modal) {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function addUpgradeOverlay(element, featureName) {
    if (!element || !element.parentNode) return;

    document.querySelectorAll('.jj-upgrade-overlay').forEach(function (overlay) {
      overlay.remove();
    });

    const host = element.closest('.jj-hero, .jj-prioritycard, .jj-recpro, .jj-rail, .jj-topbar, .jj-droom, .jj-signalaudit, .jj-verdictengine, .jj-command, .jj-section, section, article') || element.parentNode;
    if (host.querySelector('.jj-upgrade-overlay')) return;

    if (!host.style.position) {
      host.style.position = 'relative';
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'jj-upgrade-overlay';
    wrapper.innerHTML = `
      <div class="jj-upgrade-card">
        <p class="jj-upgrade-title">Upgrade Access</p>
        <p class="jj-upgrade-text">Closet System is available to Private Desk Subscribers and Advisory Clients</p>
        <button class="jj-upgrade-btn" type="button">Apply For Access</button>
      </div>
    `;

    host.appendChild(wrapper);

    const upgradeButton = wrapper.querySelector('.jj-upgrade-btn');
    if (upgradeButton) {
      upgradeButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = JJ_PRIVATE_DESK_APPLICATION_URL;
      });
    }
  }

  const chatModal = byId('jjChatModal');
  const apptModal = byId('jjAppointmentsModal');
  const closetModal = byId('jjClosetEditModal');
  const garmentModal = byId('jjGarmentCareModal');
  const profileModal = byId('jjProfileModal');

  [
    byId('jj-open-chat'),
    byId('jj-open-chat-topbar'),
    byId('jj-open-chat-priority')
  ].filter(Boolean).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!userAccess.canMessage) {
        addUpgradeOverlay(btn, 'Private Advisory Chat');
        return;
      }
      jjOpenChatModal();
    });
  });

  [
    byId('jj-open-appointments'),
    byId('jj-open-appointments-topbar'),
    byId('jj-open-appointments-recpro'),
    byId('jj-open-appointments-priority')
  ].filter(Boolean).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!userAccess.canBook) {
        addUpgradeOverlay(btn, 'Appointments');
        return;
      }
      openModal(apptModal);
    });
  });

  [
    byId('jj-open-closet-edit'),
    byId('jj-open-closet-edit-topbar'),
    byId('jj-open-closet-edit-signal'),
    byId('jj-open-closet-edit-droom')
  ].filter(Boolean).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!userAccess.canSaveCloset) {
        addUpgradeOverlay(btn, 'Closet System');
        return;
      }

      openModal(closetModal);

      if (window.JJCloset && window.JJCloset.load) {
        window.JJCloset.load();
      }
    });
  });

  [byId('jj-open-garment-care')].filter(Boolean).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!userAccess.canGarmentCare) {
        addUpgradeOverlay(btn, 'Garment Care');
        return;
      }
      openModal(garmentModal);
    });
  });

  [
    byId('jj-open-profile'),
    byId('jj-open-profile-topbar'),
    byId('jj-open-profile-priority'),
    byId('jj-open-profile-recpro')
  ].filter(Boolean).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!userAccess.canProfile) {
        addUpgradeOverlay(btn, 'Profile');
        return;
      }
      openModal(profileModal);
    });
  });

  [
    [byId('jj-chat-close'), chatModal],
    [byId('jj-chat-close-backdrop'), chatModal],
    [byId('jj-appointments-close'), apptModal],
    [byId('jj-appointments-close-backdrop'), apptModal],
    [byId('jj-closet-close'), closetModal],
    [byId('jj-closet-close-backdrop'), closetModal],
    [byId('jj-garment-close'), garmentModal],
    [byId('jj-garment-close-backdrop'), garmentModal],
    [byId('jj-profile-close'), profileModal],
    [byId('jj-profile-close-backdrop'), profileModal]
  ].forEach(function (pair) {
    if (pair[0]) {
      pair[0].addEventListener('click', function () {
        closeModal(pair[1]);
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    [chatModal, apptModal, closetModal, garmentModal, profileModal].forEach(function (modal) {
      if (modal && modal.classList.contains('is-open')) {
        closeModal(modal);
      }
    });
  });

  /* ===============================
     APPOINTMENT FORM
  ================================ */

  function initAppointmentFormBodyBuilder() {
    const form = byId('jjAppointmentRequestForm');
    const bodyField = byId('jj-appointment-body');
    if (!form || !bodyField) return;

    function fieldValue(id) {
      const el = byId(id);
      return el && el.value ? el.value.trim() : '';
    }

    form.addEventListener('submit', function () {
      const parts = [];
      const service = fieldValue('jj-appointment-service');
      const city = fieldValue('jj-appointment-city');
      const date = fieldValue('jj-appointment-date');
      const time = fieldValue('jj-appointment-time');
      const timingNote = fieldValue('jj-appointment-timing-note');
      const notes = fieldValue('jj-appointment-notes');
      const timing = [date, jjFormatPrivateDeskTime(time)].filter(Boolean).join(' at ');

      if (service) parts.push('Service Requested: ' + service);
      if (city) parts.push('City: ' + city);
      if (timing) parts.push('Preferred Timing: ' + timing);
      if (timingNote) parts.push('Timing Note: ' + timingNote);
      if (notes) parts.push('Scope / Notes: ' + notes);

      bodyField.value = parts.join('\n\n');
    });
  }

  function jjFormatPrivateDeskTime(value) {
    if (!value) return '';
    const match = String(value).match(/^(\d{1,2}):(\d{2})/);
    if (!match) return value;

    let hour = parseInt(match[1], 10);
    const minute = match[2];
    const suffix = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;
    return hour + ':' + minute + ' ' + suffix;
  }

  function jjFormatServiceDate(value) {
    if (!value) return '';
    const date = new Date(value + 'T12:00:00');
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }

  function initSubscriberWorkbenchLayout() {
    if (byId('jj-subscriber-workbench-style')) return;

    const style = document.createElement('style');
    style.id = 'jj-subscriber-workbench-style';
    style.textContent = `
      @media (min-width: 1181px){
        .jj-main{display:grid !important;grid-template-columns:minmax(0,760px) minmax(360px,420px) !important;gap:18px !important;align-items:start !important;justify-content:center !important;}
        .jj-main > *{grid-column:1 / -1 !important;min-width:0 !important;}
        .jj-main > #jj-dressing-room{grid-column:1 / -1 !important;grid-row:auto !important;content-visibility:visible !important;}
        .jj-main > #jj-authority-read{grid-column:1 / -1 !important;grid-row:auto !important;content-visibility:visible !important;max-width:100% !important;overflow:visible !important;}
        .jj-main > #jj-verdictengine{grid-column:1 / -1 !important;grid-row:auto !important;align-self:start !important;position:relative !important;top:auto !important;max-height:none !important;overflow:visible !important;content-visibility:visible !important;scrollbar-width:thin !important;z-index:8 !important;}
        .jj-main > #jj-verdictengine .jj-verdictengine__head{padding:26px 24px 18px !important;}
        .jj-main > #jj-verdictengine .jj-verdictengine__title{max-width:11ch !important;font-size:42px !important;}
        .jj-main > #jj-verdictengine .jj-verdictintake{display:grid !important;grid-template-columns:1fr !important;gap:14px !important;padding:18px 18px 22px !important;}
        .jj-main > #jj-verdictengine .jj-verdictintake__left,
        .jj-main > #jj-verdictengine .jj-verdictintake__right,
        .jj-main > #jj-verdictengine .jj-verdictfocus{padding:18px !important;}
        .jj-main > #jj-verdictengine .jj-verdictintake__title{font-size:30px !important;}
        .jj-main > #jj-verdictengine .jj-verdictupload__preview{min-height:170px !important;}
        .jj-main > #jj-verdictengine .jj-verdictfield__textarea{min-height:88px !important;}
        .jj-main > #jj-verdictengine .jj-verdictfocus__title{font-size:42px !important;}
        .jj-main > #jj-verdictengine .jj-verdictfocus__cards{margin:16px 0 14px !important;}
        .jj-main > #jj-verdictengine .jj-verdictfocus__intelligence{grid-template-columns:1fr !important;}
      }
      @media (min-width:1181px) and (max-width:1380px){
        .jj-main{grid-template-columns:minmax(0,640px) minmax(320px,370px) !important;}
        .jj-main > #jj-verdictengine .jj-verdictengine__title{font-size:36px !important;}
      }
    `;
    document.head.appendChild(style);
  }

  function initPrivateDeskSectionOrder() {
    const main = document.querySelector('.jj-main');
    const authorityRead = byId('jj-authority-read');
    const dressingRoom = byId('jj-dressing-room');
    if (!main || !authorityRead || !dressingRoom) return;

    const dressingRoomNext = dressingRoom.nextSibling;
    main.insertBefore(dressingRoom, authorityRead);

    if (dressingRoomNext && dressingRoomNext.parentNode === main) {
      main.insertBefore(authorityRead, dressingRoomNext);
    } else {
      main.appendChild(authorityRead);
    }
  }

  function initPrivateDeskUiRefinements() {
    initSubscriberWorkbenchLayout();

    const inboxBtn = byId('jj-open-chat-topbar');
    if (inboxBtn) {
      const label = inboxBtn.querySelector('span');
      if (label) label.textContent = 'Ask Jerry';
    }

    const apptBtn = byId('jj-open-appointments-topbar');
    if (apptBtn) {
      const value = apptBtn.querySelector('strong');
      if (value) value.textContent = 'Book';
    }

    const closetTopbarBtn = byId('jj-open-closet-edit-topbar');
    if (closetTopbarBtn) {
      closetTopbarBtn.setAttribute('hidden', 'hidden');
      closetTopbarBtn.style.display = 'none';
    }

    const approvalCount = byId('jj-topbar-approvals-count');
    const trackerItem = approvalCount ? approvalCount.closest('.jj-topbar__item') : null;
    if (trackerItem) {
      const label = trackerItem.querySelector('span');
      if (label) label.textContent = 'Piece Tracker';
      approvalCount.textContent = 'Track';
      trackerItem.setAttribute('href', '#');
      trackerItem.setAttribute('role', 'button');
      trackerItem.addEventListener('click', function (event) {
        event.preventDefault();
        if (!userAccess.canGarmentCare) {
          addUpgradeOverlay(trackerItem, 'Piece Tracker');
          return;
        }
        openModal(garmentModal);
      });
    }

    const closetSaveBtn = byId('jj-closet-save');
    if (closetSaveBtn) closetSaveBtn.textContent = 'Submit Request';

    const appointmentIntro = document.querySelector('.jj-appointmentmodal__intro');
    if (appointmentIntro) {
      appointmentIntro.textContent = 'Choose a date and preferred time. The desk will confirm privately.';
    }

    const dateField = byId('jj-appointment-date');
    if (dateField && !byId('jj-appointment-time')) {
      const dateWrap = dateField.closest('.jj-appointmentform__field');
      const timeWrap = document.createElement('div');
      timeWrap.className = 'jj-appointmentform__field jj-appointmentform__field--full jj-appointment-time-field';
      timeWrap.innerHTML = `
        <label for="jj-appointment-time">Preferred Time</label>
        <input id="jj-appointment-time" type="time" name="contact[Preferred Time]">
      `;
      if (dateWrap && dateWrap.parentNode) {
        dateWrap.parentNode.insertBefore(timeWrap, dateWrap.nextSibling);
      }
    }

    const timingNote = byId('jj-appointment-timing-note');
    const timingWrap = timingNote ? timingNote.closest('.jj-appointmentform__field') : null;
    if (timingWrap) timingWrap.style.display = 'none';

    const helper = document.querySelector('.jj-appointmentform__helper');
    if (helper) helper.style.display = 'none';

    const garmentTicket = byId('jj-garment-ticket');
    const garmentVendor = byId('jj-garment-vendor');
    const garmentAnchor = garmentTicket || garmentVendor || byId('jj-garment-notes');
    ['jj-garment-status', 'jj-garment-ready', 'jj-garment-ticket'].forEach(function (id) {
      const field = byId(id);
      const wrap = field ? field.closest('.jj-serviceform__field') : null;
      if (wrap) wrap.style.display = 'none';
    });
    if (garmentAnchor && !byId('jj-garment-photos')) {
      const anchorWrap = garmentAnchor.closest('.jj-serviceform__field');
      const photoWrap = document.createElement('div');
      photoWrap.className = 'jj-serviceform__field jj-serviceform__field--full';
      photoWrap.innerHTML = `
        <label for="jj-garment-photos">Piece Photos</label>
        <input id="jj-garment-photos" type="file" accept="image/*" multiple>
        <div class="jj-serviceform__helper">Upload photos of the piece, repair area, label, or anything the desk should see.</div>
      `;
      if (anchorWrap && anchorWrap.parentNode) {
        anchorWrap.parentNode.insertBefore(photoWrap, anchorWrap.nextSibling);
      }
    }

    jjUpdateOperatingRail();
  }

  function jjPlural(count, singular, plural) {
    return String(count) + ' ' + (count === 1 ? singular : (plural || singular + 's'));
  }

  function jjSetRailCopy(selector, title, detail, state) {
    const el = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!el) return;

    const titleEl = el.querySelector('span');
    const detailEl = el.querySelector('em') || el.querySelector('strong');
    if (titleEl && title) titleEl.textContent = title;
    if (detailEl && detail) detailEl.textContent = detail;
    if (state) el.setAttribute('data-rail-state', state);
  }

  function jjSetTopbarCopy(id, title, value, state) {
    const el = typeof id === 'string' ? byId(id) : id;
    if (!el) return;

    const titleEl = el.querySelector('span');
    const valueEl = el.querySelector('strong');
    if (titleEl && title) titleEl.textContent = title;
    if (valueEl && value) valueEl.textContent = value;
    if (state) el.setAttribute('data-rail-state', state);
  }

  function jjActiveServiceRequests(kind) {
    const inactive = ['completed', 'complete', 'returned', 'returned to client', 'delivered', 'closed', 'cancelled', 'canceled'];
    const requests = kind === 'garment' && jjGarmentCareJobs.length
      ? jjGarmentCareJobs
      : jjSavedServiceRequests(kind);
    return requests.filter(function (request) {
      return !inactive.includes(String(request.status || '').trim().toLowerCase());
    });
  }

  function jjReadyServiceRequests(kind) {
    const requests = kind === 'garment' && jjGarmentCareJobs.length
      ? jjGarmentCareJobs
      : jjSavedServiceRequests(kind);
    return requests.filter(function (request) {
      return /ready|pickup|delivery|collected|received/i.test(String(request.status || ''));
    });
  }

  function jjProfileCompletionScore(profile) {
    const read = function (id, fallback) {
      const el = byId(id);
      if (el && el.value) return String(el.value).trim();
      return String(fallback || '').trim();
    };
    const overview = profile && profile.overview ? profile.overview : {};
    const fit = profile && profile.fit_sizes ? profile.fit_sizes : {};
    const preferences = profile && profile.preferences ? profile.preferences : {};
    const uploads = profile && profile.uploads ? profile.uploads : {};
    const fields = [
      window.JJ_PROFILE_PORTRAIT_URL || uploads.portrait_url,
      read('jj-profile-name', overview.name),
      read('jj-profile-city', overview.city),
      read('jj-profile-phone', overview.phone),
      read('jj-profile-ship', overview.shipping_notes),
      read('jj-profile-size-top', fit.top_size),
      read('jj-profile-size-bottom', fit.bottom_size),
      read('jj-profile-size-dress', fit.dress_size),
      read('jj-profile-size-shoe', fit.shoe_size),
      read('jj-profile-fit', fit.preferred_fit),
      read('jj-profile-tailoring', fit.tailoring_notes),
      read('jj-profile-measurements', fit.measurements),
      read('jj-profile-brands', preferences.brand_preferences),
      read('jj-profile-colors', preferences.color_preferences),
      read('jj-profile-avoid', preferences.avoid),
      read('jj-profile-priority', preferences.category_priorities),
      read('jj-profile-lifestyle', preferences.lifestyle_needs),
      read('jj-profile-spend', preferences.spending_posture)
    ];
    const complete = fields.filter(Boolean).length;
    return Math.round((complete / fields.length) * 100);
  }

  function jjUpdateOperatingRail(profile) {
    const openThreads = jjInboxSummary
      ? Number(jjInboxSummary.openThreadCount || jjInboxSummary.openCount || 0)
      : (Array.isArray(jjThreads) ? jjThreads.filter(function (thread) {
        return String(thread.status || 'open').toLowerCase() === 'open';
      }).length : 0);
    const closetCount = Array.isArray(jjClientItems) ? jjClientItems.length : 0;
    const garmentActive = jjActiveServiceRequests('garment');
    const garmentReady = jjReadyServiceRequests('garment');
    const profileScore = jjProfileCompletionScore(profile);
    const nextEvent = (byId('jj-topbar') && byId('jj-topbar').dataset.nextEvent) || '';

    jjSetRailCopy('#jj-open-chat', 'Ask Jerry', openThreads ? jjPlural(openThreads, 'open thread') : 'Start request', openThreads ? 'active' : 'empty');
    jjSetRailCopy('#jj-open-appointments', 'Appointments', nextEvent ? 'Next: ' + nextEvent : 'Book time', nextEvent ? 'active' : 'empty');
    jjSetRailCopy('#jj-open-closet-edit', 'Closet Edit', closetCount ? jjPlural(closetCount, 'piece') + ' uploaded' : 'Start wardrobe rail', closetCount ? 'active' : 'empty');
    jjSetRailCopy('#jj-open-garment-care', 'Garment Care', garmentReady.length ? jjPlural(garmentReady.length, 'ready') : (garmentActive.length ? jjPlural(garmentActive.length, 'in progress') : 'Add service'), garmentActive.length ? 'active' : 'empty');
    jjSetRailCopy('#jj-open-profile', 'Profile', profileScore + '% complete', profileScore >= 80 ? 'ready' : 'needs-action');

    jjSetTopbarCopy('jj-open-chat-topbar', 'Ask Jerry', openThreads ? String(openThreads) + ' open' : 'Start', openThreads ? 'active' : 'empty');
    jjSetTopbarCopy('jj-open-appointments-topbar', 'Appointments', nextEvent ? 'Next' : 'Book', nextEvent ? 'active' : 'empty');

    const trackerValue = garmentActive.length
      ? String(garmentActive.length) + ' in care'
      : 'Start';
    const trackerTopbar = byId('jj-topbar-approvals-count')
      ? byId('jj-topbar-approvals-count').closest('.jj-topbar__item')
      : null;
    jjSetTopbarCopy(trackerTopbar, 'Piece Tracker', trackerValue, garmentActive.length ? 'active' : 'empty');
  }

  function jjServiceStorageKey(kind) {
    const owner = jjClientOwnerId(jjAuthUser || jjConsentClient());
    return 'jj_private_desk_' + kind + '_requests_' + owner;
  }

  function jjSavedServiceRequests(kind) {
    try {
      return JSON.parse(window.localStorage.getItem(jjServiceStorageKey(kind)) || '[]');
    } catch (error) {
      return [];
    }
  }

  function jjSaveServiceRequest(kind, request) {
    try {
      const requests = jjSavedServiceRequests(kind);
      requests.unshift(request);
      window.localStorage.setItem(jjServiceStorageKey(kind), JSON.stringify(requests.slice(0, 12)));
    } catch (error) {
      console.warn('Unable to save local service request:', error);
    }
  }

  function jjNormalizeGarmentCareJob(job) {
    const publicUpdate = job.client_update || job.client_facing_update || '';
    const detail = [
      job.service_needed || job.service_type,
      job.vendor_specialist || job.vendor_name,
      job.business_location
    ].filter(Boolean).join(' / ');

    return {
      id: job.id || job.local_id || '',
      title: job.piece_description || job.garment_name || job.piece_type || 'Garment Care',
      status: job.status || 'Requested',
      detail: publicUpdate || detail,
      date: jjFormatServiceDate(job.estimated_ready_date || job.expected_completion_date || job.client_dropoff_date || job.dropoff_date),
      service_needed: job.service_needed || job.service_type || '',
      piece_type: job.piece_type || '',
      vendor_specialist: job.vendor_specialist || job.vendor_name || '',
      business_location: job.business_location || '',
      service_charge: job.service_charge || job.quoted_cost || '',
      ticket_number: job.ticket_number || job.ticket_claim_number || '',
      photo_urls: job.photo_urls || [],
      ticket_urls: job.ticket_urls || []
    };
  }

  function jjGarmentCareRowsForRender() {
    if (jjGarmentCareJobs.length) return jjGarmentCareJobs.map(jjNormalizeGarmentCareJob);
    return jjSavedServiceRequests('garment');
  }

  async function jjLoadGarmentCareJobs() {
    try {
      const supabase = await jjInitSupabase();
      const user = await jjGetOptionalAuthUser();
      const ownerId = jjClientOwnerId(user);
      const email = jjClientEmail(user);
      let query = supabase
        .from(JJ_GARMENT_CARE_TABLE)
        .select('id,user_id,client_email,shopify_customer_id,created_by_role,service_needed,piece_type,piece_description,vendor_specialist,client_dropoff_date,photo_urls,ticket_urls,status,business_location,staff_dropoff_date,estimated_ready_date,service_charge,ticket_number,client_update,notes,created_at,updated_at')
        .order('updated_at', { ascending: false });

      const filters = [];
      if (user && user.id) filters.push('user_id.eq.' + user.id);
      if (email) filters.push('client_email.eq.' + email);
      if (client.shopifyCustomerId) filters.push('shopify_customer_id.eq.' + String(client.shopifyCustomerId));

      if (filters.length > 1) {
        query = query.or(filters.join(','));
      } else if (filters.length === 1) {
        const parts = filters[0].split('.eq.');
        query = query.eq(parts[0], parts[1]);
      } else {
        query = query.eq('user_id', ownerId);
      }

      const result = await query;
      if (result.error) throw result.error;
      jjGarmentCareJobs = result.data || [];
    } catch (error) {
      jjGarmentCareJobs = [];
      console.warn('Live garment care jobs unavailable; using local fallback:', error && error.message ? error.message : error);
    }
  }

  async function jjSaveGarmentCareJob(record) {
    try {
      const supabase = await jjInitSupabase();
      const user = await jjGetOptionalAuthUser();
      const ownerId = jjClientOwnerId(user);
      const email = jjClientEmail(user);
      const insertRecord = {
        user_id: user && user.id ? user.id : ownerId,
        client_email: email,
        shopify_customer_id: client.shopifyCustomerId ? String(client.shopifyCustomerId) : null,
        created_by_role: 'client',
        status: 'Requested',
        ...record,
        client_update: 'Your garment care request has been received by the desk.',
        updated_at: new Date().toISOString()
      };

      const result = await supabase
        .from(JJ_GARMENT_CARE_TABLE)
        .insert(insertRecord)
        .select('*')
        .single();

      if (result.error) throw result.error;
      if (result.data) {
        jjGarmentCareJobs.unshift(result.data);
      }
      return result.data;
    } catch (error) {
      console.warn('Unable to save live garment care job; using local fallback:', error && error.message ? error.message : error);
      return null;
    }
  }

  function jjRenderServiceTracker(kind, targetId) {
    const target = byId(targetId);
    if (!target) return;

    const requests = kind === 'garment'
      ? jjGarmentCareRowsForRender()
      : jjSavedServiceRequests(kind);
    if (!requests.length) {
      target.innerHTML = '<div class="jj-empty">No pieces submitted yet.</div>';
      jjUpdateOperatingRail();
      return;
    }

    target.innerHTML = requests.map(function (request) {
      const photos = Array.isArray(request.photo_urls) ? request.photo_urls.filter(Boolean) : [];
      const tickets = Array.isArray(request.ticket_urls) ? request.ticket_urls.filter(Boolean) : [];
      const media = photos.concat(tickets).slice(0, 3);
      return `
        <div class="jj-servicecard">
          ${media.length ? `
            <div class="jj-servicecard__media">
              ${media.map(function (url) {
                return `<a href="${jjEscapeHtml(url)}" target="_blank" rel="noopener"><img src="${jjEscapeHtml(url)}" alt="${jjEscapeHtml(request.title || 'Garment care piece')}" loading="lazy" decoding="async"></a>`;
              }).join('')}
            </div>
          ` : ''}
          <strong>${jjEscapeHtml(request.title || 'Private Desk Request')}</strong>
          <span>${jjEscapeHtml(request.status || 'Submitted')}</span>
          ${kind === 'garment' && request.detail ? `
            <p class="jj-servicecard__desk-note"><b>Desk Update</b>${jjEscapeHtml(request.detail || '')}</p>
          ` : `<p>${jjEscapeHtml(request.detail || '')}</p>`}
          <em>${jjEscapeHtml(request.date || '')}</em>
        </div>
      `;
    }).join('');
    jjUpdateOperatingRail();
  }

  async function jjUploadServiceFiles(input, folder) {
    const files = input && input.files ? Array.prototype.slice.call(input.files) : [];
    if (!files.length) return [];

    const supabase = await jjInitSupabase();
    if (!supabase) return [];

    const owner = jjClientOwnerId(await jjGetOptionalAuthUser());
    const urls = [];

    for (const file of files.slice(0, 4)) {
      const ext = (file.name.split('.').pop() || 'jpg').toLowerCase();
      const safeName = Date.now() + '-' + Math.random().toString(36).slice(2) + '.' + ext;
      const filePath = folder + '/' + owner + '/' + safeName;
      const result = await supabase.storage
        .from('ask-jerry-images')
        .upload(filePath, file, { upsert: true });

      if (!result.error) {
        urls.push(supabase.storage.from('ask-jerry-images').getPublicUrl(filePath).data.publicUrl);
      }
    }

    return urls;
  }

  function jjServiceLine(label, value) {
    return value ? label + ': ' + value : '';
  }

  function initPrivateDeskServiceRequests() {
    const closetSave = byId('jj-closet-save');
    if (closetSave) {
      closetSave.addEventListener('click', async function () {
        if (!userAccess.canSaveCloset) {
          addUpgradeOverlay(closetSave, 'Closet System');
          return;
        }

        const session = byId('jj-closet-session') ? byId('jj-closet-session').value : '';
        const location = byId('jj-closet-location') ? byId('jj-closet-location').value : '';
        const date = byId('jj-closet-date') ? byId('jj-closet-date').value : '';
        const challenge = byId('jj-closet-challenge') ? byId('jj-closet-challenge').value : '';
        const notes = byId('jj-closet-notes') ? byId('jj-closet-notes').value.trim() : '';
        const status = byId('jj-closet-status') || byId('jj-chat-status');

        try {
          closetSave.disabled = true;
          if (status) status.textContent = 'Submitting closet request...';

          const photoUrls = await jjUploadServiceFiles(byId('jj-closet-upload'), 'closet-requests');
          const message = [
            jjServiceLine('Session Type', session),
            jjServiceLine('Location', location),
            jjServiceLine('Preferred Date', jjFormatServiceDate(date)),
            jjServiceLine('Current Challenge', challenge),
            jjServiceLine('Scope / Notes', notes),
            photoUrls.length ? 'Photos: ' + photoUrls.join(', ') : ''
          ].filter(Boolean).join('\n\n');

          await jjCreateThread('Closet Calibration: ' + (session || 'Request'), message, photoUrls[0] || null);
          jjSaveServiceRequest('closet', {
            title: session || 'Closet Calibration',
            status: 'Submitted',
            detail: challenge || notes,
            date: jjFormatServiceDate(date) || new Date().toLocaleDateString()
          });
          jjRenderServiceTracker('closet', 'jj-closet-requests');
          if (status) status.textContent = 'Closet request submitted.';
          alert('Closet request submitted.');
        } catch (error) {
          console.error('CLOSET REQUEST ERROR:', error);
          alert('Unable to submit closet request.');
        } finally {
          closetSave.disabled = false;
        }
      });
    }

    const garmentSave = byId('jj-garment-save');
    if (garmentSave) {
      garmentSave.addEventListener('click', async function () {
        if (!userAccess.canGarmentCare) {
          addUpgradeOverlay(garmentSave, 'Garment Care');
          return;
        }

        const service = byId('jj-garment-service') ? byId('jj-garment-service').value : '';
        const type = byId('jj-garment-piece-type') ? byId('jj-garment-piece-type').value : '';
        const piece = byId('jj-garment-piece') ? byId('jj-garment-piece').value.trim() : '';
        const vendor = byId('jj-garment-vendor') ? byId('jj-garment-vendor').value.trim() : '';
        const dropoff = byId('jj-garment-dropoff') ? byId('jj-garment-dropoff').value : '';
        const notes = byId('jj-garment-notes') ? byId('jj-garment-notes').value.trim() : '';

        try {
          garmentSave.disabled = true;

          const photoUrls = await jjUploadServiceFiles(byId('jj-garment-photos'), 'garment-care');
          const ticketUrls = await jjUploadServiceFiles(byId('jj-garment-ticket'), 'garment-care-tickets');
          const allUrls = photoUrls.concat(ticketUrls);
          const message = [
            jjServiceLine('Service Needed', service),
            jjServiceLine('Piece Type', type),
            jjServiceLine('Piece', piece),
            jjServiceLine('Vendor / Specialist', vendor),
            jjServiceLine('Client Drop-off Date', jjFormatServiceDate(dropoff)),
            jjServiceLine('Scope / Notes', notes),
            allUrls.length ? 'Photos / Tickets: ' + allUrls.join(', ') : ''
          ].filter(Boolean).join('\n\n');

          await jjCreateThread('Garment Care: ' + (piece || type || service || 'Piece'), message, allUrls[0] || null);
          const savedJob = await jjSaveGarmentCareJob({
            service_needed: service,
            piece_type: type,
            piece_description: piece,
            vendor_specialist: vendor,
            client_dropoff_date: dropoff || null,
            notes: notes,
            photo_urls: photoUrls,
            ticket_urls: ticketUrls
          });
          if (!savedJob) jjSaveServiceRequest('garment', {
            title: piece || type || service || 'Garment Care',
            status: 'Requested',
            detail: [service, vendor].filter(Boolean).join(' / '),
            date: jjFormatServiceDate(dropoff) || new Date().toLocaleDateString()
          });
          await jjLoadGarmentCareJobs();
          jjRenderServiceTracker('garment', 'jj-garment-tracker');
          alert('Garment care ticket submitted.');
        } catch (error) {
          console.error('GARMENT CARE ERROR:', error);
          alert('Unable to submit garment care ticket.');
        } finally {
          garmentSave.disabled = false;
        }
      });
    }

    jjRenderServiceTracker('closet', 'jj-closet-requests');
    jjLoadGarmentCareJobs().then(function () {
      jjRenderServiceTracker('garment', 'jj-garment-tracker');
    });
  }

  /* ===============================
     CHAT
  ================================ */

  let jjCurrentThreadId = null;
  let jjThreads = [];
  let jjActiveThread = null;
  let jjInboxSummary = null;

  async function jjPost(path, payload) {
    const res = await fetch(`${window.JJ_API_BASE}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload || {})
    });

    const data = await res.json();
    if (!res.ok || data.ok === false) {
      throw new Error(data.error || 'Request failed');
    }
    return data;
  }

  async function jjSyncClient() {
    if (!client.shopifyCustomerId) {
      throw new Error('Missing Shopify customer ID.');
    }

    return jjPost('/client-sync', {
      shopifyCustomerId: client.shopifyCustomerId,
      email: client.email,
      firstName: client.firstName,
      lastName: client.lastName,
      authorityRole: client.authorityRole || client.authority_role,
      bodyProfile: client.bodyProfile,
      brandAffinity: client.brandAffinity,
      spendProfile: client.spendProfile,
      categoryPreference: client.categoryPreference,
      nextEvent: client.nextEvent,
      watchlistBrands: client.watchlistBrands,
      watchlistCategories: client.watchlistCategories,
      watchlistNotes: client.watchlistNotes
    });
  }

  async function jjLoadInboxSummary() {
    const data = await jjPost('/inbox-summary', {
      shopifyCustomerId: client.shopifyCustomerId
    });
    jjInboxSummary = data.summary || null;
    return data;
  }

  async function jjLoadThreads() {
    const data = await jjPost('/threads-list', {
      shopifyCustomerId: client.shopifyCustomerId
    });
    jjThreads = data.threads || [];
    return jjThreads;
  }

  async function jjLoadThreadDetail(threadId) {
    const data = await jjPost('/thread-detail', { threadId: threadId });
    jjActiveThread = data.thread || null;
    jjCurrentThreadId = threadId;
    return data;
  }

  function jjBuildThreadSubject(message) {
    const text = String(message || '').trim();
    if (!text) return 'Private Override Request';

    const lower = text.toLowerCase();
    if (/shirt|button down|button-down|polo/.test(lower)) return 'Shirt Guidance Request';
    if (/suit|blazer|tailoring|trouser|jacket/.test(lower)) return 'Tailoring Request';
    if (/shoe|loafer|heel|boot|sandal/.test(lower)) return 'Shoe Request';
    if (/bag|handbag|purse|clutch/.test(lower)) return 'Bag Request';
    if (/event|dinner|gala|wedding|cocktail|board meeting|meeting/.test(lower)) return 'Event Dressing Request';
    if (/travel|trip|vacation|packing/.test(lower)) return 'Travel Wardrobe Request';
    if (/closet|wardrobe edit|closet edit/.test(lower)) return 'Closet Review Request';
    if (/jewelry|watch|accessory|accessories/.test(lower)) return 'Accessory Request';
    if (text.length <= 48) return text;
    return text.slice(0, 45).trim() + '...';
  }

  async function jjCreateThread(subject, initialMessage, attachmentUrl) {
    const data = await jjPost('/threads-create', {
      shopifyCustomerId: client.shopifyCustomerId,
      subject: subject || 'Private Override Request',
      threadType: 'private_override',
      priority: 'normal',
      source: 'dashboard',
      createdBy: 'client',
      senderName: client.fullName || client.name || 'Client',
      initialMessage: initialMessage,
      attachmentUrl: attachmentUrl || null
    });

    jjCurrentThreadId = data.thread.id;
    return data;
  }

  async function jjSendMessage(threadId, messageBody, attachmentUrl) {
    return jjPost('/threads-message', {
      threadId: threadId,
      senderType: 'client',
      senderName: client.fullName || client.name || 'Client',
      messageBody: messageBody,
      attachmentUrl: attachmentUrl || null
    });
  }

  function jjRenderInboxSummary() {
    const topCount = byId('jj-topbar-inbox-count');
    const openCount = byId('jj-chat-open-count');
    const count = jjInboxSummary ? String(jjInboxSummary.openThreadCount || jjInboxSummary.openCount || 0) : '0';
    if (topCount) topCount.textContent = count;
    if (openCount) openCount.textContent = count;
    jjUpdateOperatingRail();
  }

  function jjRenderThreadList() {
    const listEl = byId('jj-thread-list');
    const countEl = byId('jj-chat-thread-count');

    if (countEl) countEl.textContent = String(jjThreads.length || 0);
    if (!listEl) return;

    if (!jjThreads.length) {
      listEl.innerHTML = '<div class="jj-empty">No threads yet.</div>';
      jjUpdateOperatingRail();
      return;
    }

    listEl.innerHTML = jjThreads.map(function (thread) {
      const active = jjCurrentThreadId === thread.id ? ' is-active' : '';
      return `
        <button type="button" class="jj-thread-item${active}" data-thread-id="${jjEscapeHtml(thread.id)}">
          <div class="jj-thread-item__subject">${jjEscapeHtml(thread.subject || 'Private Override Request')}</div>
          <div class="jj-thread-item__meta">${jjEscapeHtml((thread.thread_type || 'private_override') + ' • ' + (thread.status || 'open'))}</div>
        </button>
      `;
    }).join('');
    jjUpdateOperatingRail();
  }

  function jjRenderThreadMessages(messages) {
    const messagesEl = byId('jj-thread-messages');
    if (!messagesEl) return;

    if (!messages || !messages.length) {
      messagesEl.innerHTML = '<div class="jj-empty">Start a new private request. Your next message will open a new thread.</div>';
      return;
    }

    messagesEl.innerHTML = messages.map(function (msg) {
      const mine = msg.sender_type === 'client';
      const attachmentHtml = msg.attachment_url
        ? `<div class="jj-message__attachment"><img src="${jjEscapeHtml(msg.attachment_url)}" alt="Attached client image" loading="lazy"></div>`
        : '';

      return `
        <div class="jj-message${mine ? ' is-client' : ' is-jerry'}">
          <div class="jj-message__name">${jjEscapeHtml(msg.sender_name || msg.sender_type || 'Message')}</div>
          <div class="jj-message__body">${jjEscapeHtml(msg.message_body || '')}</div>
          ${attachmentHtml}
          <div class="jj-message__time">${msg.created_at ? new Date(msg.created_at).toLocaleString() : ''}</div>
        </div>
      `;
    }).join('');

    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function jjStartNewRequest(prefill) {
    jjCurrentThreadId = null;
    jjActiveThread = null;

    const titleEl = byId('jj-chat-title');
    const subjectEl = byId('jj-chat-current-subject');
    const inputEl = byId('jj-chat-input');
    const messagesEl = byId('jj-thread-messages');
    const statusEl = byId('jj-chat-status');

    if (titleEl) titleEl.textContent = 'Private Advisory Chat';
    if (subjectEl) subjectEl.textContent = 'New Request';
    if (messagesEl) {
      messagesEl.innerHTML = '<div class="jj-empty">Start a new private request. Your next message will open a new thread.</div>';
    }
    if (inputEl) {
      inputEl.value = prefill || '';
      inputEl.focus();
    }
    if (statusEl) statusEl.textContent = 'New request ready.';

    jjRenderThreadList();
  }

  async function jjOpenChatModal() {
    const statusEl = byId('jj-chat-status');
    openModal(chatModal);

    try {
      if (statusEl) statusEl.textContent = 'Loading your private desk...';

      await jjSyncClient();
      await jjLoadInboxSummary();
      jjRenderInboxSummary();

      const threads = await jjLoadThreads();
      jjRenderThreadList();

      if (threads.length) {
        const detail = await jjLoadThreadDetail(threads[0].id);
        const titleEl = byId('jj-chat-title');
        const subjectEl = byId('jj-chat-current-subject');

        if (titleEl && jjActiveThread && jjActiveThread.subject) {
          titleEl.textContent = jjActiveThread.subject;
        }
        if (subjectEl && jjActiveThread && jjActiveThread.subject) {
          subjectEl.textContent = jjActiveThread.subject;
        }
        jjRenderThreadMessages(detail.messages || []);
      } else {
        jjStartNewRequest('');
      }

      if (statusEl) statusEl.textContent = '';
    } catch (error) {
      console.error(error);
      if (statusEl) statusEl.textContent = error.message || 'Unable to load your private desk.';
    }
  }

  window.jjOpenChatModal = jjOpenChatModal;
  window.JJChat = {
    open: jjOpenChatModal,
    startNewRequest: function (text) {
      jjOpenChatModal();
      setTimeout(function () {
        jjStartNewRequest(text || '');
      }, 150);
    },
    prefillAndOpen: function (text) {
      jjOpenChatModal();
      setTimeout(function () {
        jjStartNewRequest(text || '');
      }, 150);
    }
  };
  window.JJChatModal = { open: jjOpenChatModal };

  document.addEventListener('click', async function (event) {
    const threadBtn = event.target.closest('[data-thread-id]');

    if (threadBtn) {
      try {
        const threadId = threadBtn.getAttribute('data-thread-id');
        const data = await jjLoadThreadDetail(threadId);
        const titleEl = byId('jj-chat-title');
        const subjectEl = byId('jj-chat-current-subject');

        if (titleEl && jjActiveThread && jjActiveThread.subject) {
          titleEl.textContent = jjActiveThread.subject;
        }
        if (subjectEl && jjActiveThread && jjActiveThread.subject) {
          subjectEl.textContent = jjActiveThread.subject;
        }

        jjRenderThreadList();
        jjRenderThreadMessages(data.messages || []);
      } catch (error) {
        console.error(error);
      }
    }

    if (event.target && event.target.id === 'jj-command-ask-jerry') {
      const input = byId('jj-command-input');
      const output = byId('jj-command-output');
      const combined = [
        input && input.value ? input.value.trim() : '',
        output ? output.innerText.trim() : ''
      ].filter(Boolean).join('\n\n');

      await jjOpenChatModal();

      const chatInput = byId('jj-chat-input');
      if (chatInput) chatInput.value = combined.trim();
    }
  });

  const newThreadBtn = byId('jj-chat-new-thread');
  if (newThreadBtn) {
    newThreadBtn.addEventListener('click', function () {
      jjStartNewRequest('');
    });
  }

  const sendBtn = byId('jj-chat-send');
  const inputEl = byId('jj-chat-input');
  const statusEl = byId('jj-chat-status');
  const askImageInput = byId('jjAskImageInput');
  const askImageButton = byId('jjAskImageButton');
  const askImagePreview = byId('jjAskImagePreview');
  let askSelectedImage = null;

  if (askImageButton && askImageInput) {
    askImageButton.addEventListener('click', function () {
      askImageInput.click();
    });

    askImageInput.addEventListener('change', function () {
      askSelectedImage = askImageInput.files && askImageInput.files[0] ? askImageInput.files[0] : null;
      if (askImagePreview) {
        askImagePreview.textContent = askSelectedImage ? `Attached: ${askSelectedImage.name}` : '';
      }
    });
  }

  if (sendBtn && inputEl) {
    sendBtn.addEventListener('click', async function () {
      let message = inputEl.value.trim();
      if (!message && askSelectedImage) {
        message = 'Image attached for review.';
      }
      if (!message && !askSelectedImage) return;

      try {
        sendBtn.disabled = true;
        if (statusEl) statusEl.textContent = 'Sending...';

        let attachmentUrl = null;
        if (askSelectedImage) {
          const supabase = await jjInitSupabase();
          if (!supabase) {
            throw new Error('Supabase is not configured.');
          }

          const fileExt = askSelectedImage.name.split('.').pop() || 'jpg';
          const fileName = `${Date.now()}-${Math.random().toString(36).slice(2)}.${fileExt}`;
          const filePath = `ask-jerry/${fileName}`;

          const result = await supabase.storage
            .from('ask-jerry-images')
            .upload(filePath, askSelectedImage);

          if (result.error) {
            console.error('Ask Jerry image upload failed:', result.error);
            throw new Error('Image upload failed.');
          }

          const publicUrlData = supabase.storage
            .from('ask-jerry-images')
            .getPublicUrl(filePath).data;

          attachmentUrl = publicUrlData.publicUrl;
        }

        if (!jjCurrentThreadId) {
          await jjCreateThread(jjBuildThreadSubject(message || 'Image Request'), message, attachmentUrl);
        } else {
          await jjSendMessage(jjCurrentThreadId, message, attachmentUrl);
        }

        await jjLoadThreads();
        jjRenderThreadList();

        if (jjCurrentThreadId) {
          const detail = await jjLoadThreadDetail(jjCurrentThreadId);
          const titleEl = byId('jj-chat-title');
          const subjectEl = byId('jj-chat-current-subject');

          if (titleEl && jjActiveThread && jjActiveThread.subject) {
            titleEl.textContent = jjActiveThread.subject;
          }
          if (subjectEl && jjActiveThread && jjActiveThread.subject) {
            subjectEl.textContent = jjActiveThread.subject;
          }
          jjRenderThreadMessages(detail.messages || []);
        }

        await jjLoadInboxSummary();
        jjRenderInboxSummary();

        inputEl.value = '';
        askSelectedImage = null;
        if (askImageInput) askImageInput.value = '';
        if (askImagePreview) askImagePreview.textContent = '';
        if (statusEl) statusEl.textContent = 'Sent.';
      } catch (error) {
        console.error(error);
        if (statusEl) statusEl.textContent = error.message || 'Unable to send message.';
      } finally {
        sendBtn.disabled = false;
      }
    });
  }

  /* ===============================
     COMMAND CENTER
  ================================ */

  (function initCommandCenter() {
    const input = byId('jj-command-input');
    const output = byId('jj-command-output');
    const status = byId('jj-command-status');
    const buttons = document.querySelectorAll('.jj-command__btn');
    const quickPrompts = document.querySelectorAll('.jj-command__quickprompt');

    if (!input || !output || !status || !buttons.length) return;

    Array.prototype.forEach.call(quickPrompts, function (btn) {
      btn.addEventListener('click', function () {
        input.value = btn.getAttribute('data-prompt') || '';
        input.focus();
      });
    });

    function fallbackAdvisory(mode, text) {
      let headline = '';
      let summary = '';
      let items = [];

      if (mode === 'recommend') {
        headline = 'Wardrobe Recommendations';
        summary = 'The system is reading for alignment, context, authority, and completeness.';
        items = [
          { title: 'From Your Closet', reason: 'Start with the strongest existing piece that already supports your authority.', action: 'Pull one anchor look from your current wardrobe first.' },
          { title: 'What To Purchase', reason: 'Only buy the missing element that sharpens the signal or solves the visible gap.', action: 'Acquire one hero piece, not several alternatives.' },
          { title: 'Accessories', reason: 'Accessories should finish the look, not compete with it.', action: 'Choose one strong finishing layer and keep the rest quiet.' }
        ];
      } else if (mode === 'strategy') {
        headline = 'Acquisition Strategy';
        summary = 'This read is prioritizing discipline, timing, function, and clarity.';
        items = [
          { title: 'Gap First', reason: 'The right acquisition fills a real wardrobe gap rather than reacting to temporary intrigue.', action: 'Prioritize what is missing in the system.' },
          { title: 'Buy Less Broadly', reason: 'Authority is strengthened when the wardrobe is edited, not crowded.', action: 'Narrow the purchase path.' },
          { title: 'Avoid', reason: 'Skip anything overly decorative, off-message, or disconnected from the current profile.', action: 'Decline what weakens repeatability.' }
        ];
      } else {
        headline = 'Styling Direction';
        summary = 'This read is organizing the look around proportion, clarity, city, occasion, and how the client should be read in the room.';
        items = [
          { title: 'What Works', reason: 'Use the pieces that support authority, recognizability, and the strongest silhouette.', action: 'Build around the best line and proportion.' },
          { title: 'What To Avoid', reason: 'Avoid pieces that feel noisy, too trend-led, or visually in conflict with the profile.', action: 'Remove what dilutes the signal.' },
          { title: 'Next Move', reason: 'Finish only with accessories and purchases that make the outfit feel complete.', action: 'Refine, then escalate to Jerry if needed.' }
        ];
      }

      if (client.nextEvent) summary += ' Next event on file: ' + client.nextEvent + '.';
      if (client.authorityRole || client.authority_role) summary += ' Authority role: ' + (client.authorityRole || client.authority_role) + '.';
      if (text) summary += ' Request noted: ' + text;

      return { headline: headline, summary: summary, items: items };
    }

    function renderOutput(data) {
      let html = '';

      if (data.headline) {
        html += `
          <div class="jj-command__result">
            <span class="jj-command__memo">Desk Memo</span>
            <h3>${jjEscapeHtml(data.headline)}</h3>
            <p>${jjEscapeHtml(data.summary || '')}</p>
          </div>
        `;
      }

      if (Array.isArray(data.items)) {
        data.items.forEach(function (item) {
          html += `
            <div class="jj-command__result">
              <span class="jj-command__memo">Recommendation</span>
              <h3>${jjEscapeHtml(item.title || 'Recommendation')}</h3>
              <p>${jjEscapeHtml(item.reason || '')}</p>
              <em>${jjEscapeHtml(item.action || '')}</em>
            </div>
          `;
        });
      }

      html += `
        <div class="jj-command__route">
          <div>
            <span class="jj-command__routeLabel">Need Jerry involved?</span>
            <p class="jj-command__routeText">Route this into Ask Jerry for direct review.</p>
          </div>
          <button type="button" class="jj-command__routeBtn" id="jj-command-ask-jerry">Ask Jerry to Review</button>
        </div>
      `;

      output.innerHTML = html || '<div class="jj-command__result"><p>No response returned.</p></div>';
    }

    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function () {
        const text = input.value.trim();
        if (!text) {
          status.textContent = 'Enter a request first.';
          return;
        }

        status.textContent = 'Reading the request...';

        try {
          const advisory = fallbackAdvisory(btn.getAttribute('data-mode'), text);
          renderOutput(advisory);
          status.textContent = 'Direct read ready.';
        } catch (error) {
          console.error(error);
          status.textContent = 'Unable to generate advisory.';
        }
      });
    });
  })();

  /* ===============================
     VERDICT ENGINE
  ================================ */

  function initVerdictEngine() {
    const verdictRoot = byId('jj-verdictengine');
    if (!verdictRoot) return;

    const fileInput = byId('jj-verdict-file');
    const preview = byId('jj-verdict-preview');
    const runBtn = byId('jj-verdict-run');
    const resetBtn = byId('jj-verdict-reset');
    const noteInput = byId('jj-verdict-note');
    const goalInput = byId('jj-verdict-goal');
    const urgencyInput = byId('jj-verdict-urgency');
    const statusEl = byId('jj-verdict-status');
    const focusTitle = byId('jj-verdictfocus-title');
    const focusText = byId('jj-verdictfocus-text');
    const confidenceEl = byId('jj-verdict-confidence');
    const actionEl = byId('jj-verdict-action');
    const askJerryBtn = byId('jj-verdict-ask-jerry');
    const disagreeNote = byId('jj-verdict-disagree-note');
    const cards = Array.prototype.slice.call(verdictRoot.querySelectorAll('.jj-verdictcard'));
    const defaultVerdictCard = verdictRoot.querySelector('.jj-verdictcard[data-key="wait"]') || cards[0] || null;
    const remoteVerdictEndpoint = 'https://jj-intelligence-engine.vercel.app/api/buy-wait-tailor-source';

    let uploadedFile = null;
    let uploadedImageDataUrl = '';
    let uploadedVision = null;

    function setPreview(url) {
      if (!preview) return;
      if (url) {
        preview.classList.remove('is-empty');
        preview.innerHTML = `<img class="jj-verdictupload__previewImg" src="${jjEscapeHtml(url)}" alt="Uploaded piece preview">`;
      } else {
        preview.classList.add('is-empty');
        preview.innerHTML = '<div class="jj-verdictupload__previewPlaceholder">Your uploaded image will appear here.</div>';
      }
    }

    function activateCard(card) {
      cards.forEach(function (c) {
        c.classList.remove('is-active');
      });

      if (!card) return;
      card.classList.add('is-active');
      if (focusTitle) focusTitle.textContent = card.getAttribute('data-title') || '';
      if (focusText) focusText.textContent = card.getAttribute('data-text') || '';
    }

    function containsAny(haystack, arr) {
      const source = String(haystack || '').toLowerCase();
      return (arr || []).some(function (term) {
        return source.indexOf(term) > -1;
      });
    }

    function countAny(haystack, arr) {
      const source = String(haystack || '').toLowerCase();
      return (arr || []).reduce(function (count, term) {
        return count + (source.indexOf(term) > -1 ? 1 : 0);
      }, 0);
    }

    function jjVerdictContextSource() {
      const goalRaw = goalInput ? goalInput.value : '';
      const urgencyRaw = urgencyInput ? urgencyInput.value : '';
      const noteRaw = noteInput ? noteInput.value : '';
      const fileName = uploadedFile ? uploadedFile.name : '';
      const visionText = uploadedVision
        ? [
            uploadedVision.piece_type,
            uploadedVision.description,
            uploadedVision.color,
            uploadedVision.material,
            uploadedVision.silhouette,
            Array.isArray(uploadedVision.details) ? uploadedVision.details.join(' ') : ''
          ].join(' ')
        : '';

      return (noteRaw + ' ' + fileName + ' ' + goalRaw + ' ' + urgencyRaw + ' ' + visionText).trim().toLowerCase();
    }

    function jjVerdictPieceFamily(text) {
      const source = String(text || '').toLowerCase();
      if (containsAny(source, ['jacket', 'blazer', 'coat', 'outerwear', 'trench', 'bomber', 'moto', 'parka'])) return 'outerwear';
      if (containsAny(source, ['dress', 'gown'])) return 'dress';
      if (containsAny(source, ['pant', 'trouser', 'jean', 'short', 'skirt', 'bottom'])) return 'bottom';
      if (containsAny(source, ['shoe', 'sandal', 'boot', 'heel', 'loafer', 'sneaker'])) return 'shoe';
      if (containsAny(source, ['bag', 'handbag', 'tote', 'clutch', 'purse'])) return 'bag';
      if (containsAny(source, ['jewelry', 'necklace', 'bracelet', 'earring', 'ring', 'belt', 'scarf', 'sunglass', 'accessory'])) return 'accessory';
      if (containsAny(source, ['shirt', 'top', 'blouse', 'sweater', 'knit', 'tee', 'vest', 'hoodie'])) return 'top';
      return '';
    }

    function jjVerdictFamiliesMatch(uploadedFamily, closetFamily) {
      if (!uploadedFamily || !closetFamily) return false;
      if (uploadedFamily === closetFamily) return true;
      return (uploadedFamily === 'top' && closetFamily === 'garment') || (uploadedFamily === 'garment' && closetFamily === 'top');
    }

    function jjVerdictSignatureTerms(text) {
      const stopWords = {
        this: true,
        that: true,
        with: true,
        from: true,
        piece: true,
        item: true,
        upload: true,
        uploaded: true,
        image: true,
        photo: true,
        garment: true,
        closet: true,
        wardrobe: true,
        private: true,
        source: true,
        buy: true,
        wait: true,
        tailor: true,
        dress: true,
        jacket: true,
        blazer: true,
        outerwear: true,
        bottom: true,
        pants: true,
        pant: true,
        trouser: true,
        trousers: true,
        top: true,
        shirt: true,
        shoe: true,
        shoes: true,
        bag: true,
        accessory: true
      };

      return String(text || '').toLowerCase().split(/[^a-z0-9]+/).filter(function (token) {
        return token.length > 3 && !stopWords[token];
      });
    }

    function jjVerdictSignatureOverlap(source, itemText) {
      const sourceTerms = new Set(jjVerdictSignatureTerms(source));
      if (!sourceTerms.size) return 0;
      return jjVerdictSignatureTerms(itemText).reduce(function (total, term) {
        return total + (sourceTerms.has(term) ? 1 : 0);
      }, 0);
    }

    function jjVerdictIsSimilarClosetMatch(source, uploadedFamily, itemText, itemFamily) {
      if (!jjVerdictFamiliesMatch(uploadedFamily, itemFamily)) return false;
      if (containsAny(source, ['already own', 'already have', 'same as', 'similar', 'duplicate'])) return true;
      const overlap = jjVerdictSignatureOverlap(source, itemText);
      return overlap >= 1;
    }

    function jjVerdictItemText(item) {
      return [
        item && item.id,
        item && (item.piece_type || item.type),
        item && item.pieceType,
        item && item.category,
        item && item.note,
        item && item.description,
        item && item.ai_description,
        item && item.image_description,
        item && item.color,
        item && item.ai_color,
        item && item.material,
        item && item.ai_material,
        item && item.silhouette,
        item && item.ai_silhouette,
        item && (Array.isArray(item.ai_details) ? item.ai_details.join(' ') : item.ai_details),
        item && item.image_url,
        item && item.status,
        item && item.decision
      ].join(' ').toLowerCase();
    }

    function jjFindOwnedClosetMatch() {
      const source = jjVerdictContextSource();
      const uploadedFamily = jjVerdictPieceFamily(source);
      if (!uploadedFamily) return null;

      const items = Array.isArray(jjClientItems)
        ? jjClientItems
        : (Array.isArray(window.jjClientItems) ? window.jjClientItems : []);

      return items.find(function (item) {
        const itemText = jjVerdictItemText(item);
        const itemFamily = jjVerdictPieceFamily(itemText);
        const archived = containsAny(itemText, ['archive', 'archived', 'released', 'consigned']);
        return !archived && jjVerdictIsSimilarClosetMatch(source, uploadedFamily, itemText, itemFamily);
      }) || null;
    }

    function jjOwnedClosetVerdict(match) {
      const family = jjVerdictPieceFamily(jjVerdictContextSource());
      const label = family === 'outerwear' ? 'jacket or outerwear piece' : (family ? family + ' piece' : 'piece');
      const itemLabel = match && (match.note || match.ai_description || match.piece_type)
        ? ' I found a similar ' + label + ' in your closet.'
        : ' You may already own this category.';

      return {
        key: 'wait',
        confidence: 'High',
        action: 'Review the owned version first',
        status: 'Verdict ready. Similar wardrobe piece found.',
        text: 'Wait.' + itemLabel + ' You already own this, or something very similar to this. Before buying another one, ask: is this version limited edition, truly novel, or part of a collection you are intentionally building? If not, this is duplication, not a wardrobe gap.'
      };
    }

    function chooseVerdict() {
      const goalRaw = goalInput ? goalInput.value : '';
      const urgencyRaw = urgencyInput ? urgencyInput.value : '';
      const goal = jjNormalizeDecisionValue(goalRaw);
      const urgency = jjNormalizeDecisionValue(urgencyRaw);
      const noteRaw = noteInput ? noteInput.value : '';
      const note = noteRaw.toLowerCase();
      const fileName = uploadedFile ? uploadedFile.name.toLowerCase() : '';
      const source = (note + ' ' + fileName + ' ' + String(goalRaw || '') + ' ' + String(urgencyRaw || '')).trim().toLowerCase();
      const hasMeaningfulContext = note.trim().length >= 18 || Boolean(goal) || Boolean(urgency);
      const ownedMatch = jjFindOwnedClosetMatch();

      const qualityTerms = ['wool', 'cashmere', 'silk', 'linen', 'leather', 'suede', 'cotton', 'denim', 'tailored', 'structured', 'lined', 'excellent', 'quality', 'heirloom', 'investment', 'classic', 'timeless'];
      const alignmentTerms = ['need', 'gap', 'missing', 'replace', 'rotation', 'wear weekly', 'wear often', 'client', 'meeting', 'board', 'event', 'travel', 'work', 'dinner', 'authority', 'signature', 'uniform'];
      const riskTerms = ['maybe', 'unsure', 'trend', 'sale', 'cheap', 'itchy', 'synthetic', 'polyester', 'thin', 'impulse', 'logo', 'loud', 'duplicate', 'similar', 'tight', 'alter', 'tailor', 'repair', 'one time', 'one night', 'costume'];
      const fitTerms = ['too long', 'too short', 'too tight', 'too loose', 'waist', 'hem', 'sleeve', 'shoulder', 'tailor', 'alteration', 'alter', 'repair', 'needs work'];
      const sourceTerms = ['find better', 'source', 'private', 'specific', 'designer', 'rare', 'exact', 'better version', 'hunt', 'search'];
      const archiveTerms = ['collectible', 'archive', 'vintage', 'rare', 'runway', 'limited', 'investment'];
      const eventTerms = ['wedding', 'gala', 'board', 'meeting', 'presentation', 'dinner', 'trip', 'travel', 'event'];

      const qualityScore = countAny(source, qualityTerms);
      const alignmentScore = countAny(source, alignmentTerms);
      const riskScore = countAny(source, riskTerms);
      const desireLed = containsAny(source, ['splurge', 'obsessed', 'want it', 'love it', 'craving', 'must have', 'saw it', 'instagram', 'tiktok']);
      const cheapFinish = containsAny(source, ['cheap', 'poor quality', 'synthetic', 'polyester', 'thin', 'flimsy', 'shiny satin']);
      const flashy = containsAny(source, ['logo', 'loud', 'flashy', 'costume', 'novelty', 'neon', 'studded', 'bling']);
      const duplicate = containsAny(source, ['already have', 'similar', 'duplicate', 'same as', 'another black']);
      const fitIssue = containsAny(source, fitTerms);
      const oneTime = containsAny(source, ['one time', 'one night', 'single event', 'theme', 'vacation only', 'costume']);
      const privateSource = containsAny(source, sourceTerms);
      const archiveIntent = goal === 'investment' || containsAny(source, archiveTerms);
      const event = goal === 'event' || containsAny(source, eventTerms);
      const authority = goal === 'authority' || containsAny(source, ['authority', 'polished', 'executive', 'client-facing', 'presence', 'leadership', 'investor']);
      const wardrobeGap = goal === 'wardrobe_gap' || containsAny(source, ['wardrobe gap', 'fill a gap', 'missing', 'need this', 'need a', 'replace', 'do not own']);
      const wardrobeConnected = containsAny(source, ['works with', 'goes with', 'matches', 'style with', 'wear with', 'already own', 'in my closet', 'in my wardrobe', 'with my wardrobe', 'with my closet', 'existing pieces']);
      const repeatUseful = containsAny(source, ['weekly', 'often', 'wear again', 're-wear', 'rewear', 'repeat', 'versatile', 'multiple ways', 'staple', 'rotation', 'work after', 'use after', 'season', 'daily']);
      const immediate = urgency === 'immediate' || containsAny(source, ['today', 'tomorrow', 'this week', 'tonight', 'urgent', 'immediate', 'asap', 'right now']);
      const noRush = urgency === 'no_rush' || containsAny(source, ['no rush', 'not urgent', 'later', 'wait']);
      const exactNeed = wardrobeGap || event || immediate || containsAny(source, ['specific need', 'needed for', 'deadline']);
      const buyScore = (qualityScore * 2) + alignmentScore + (wardrobeConnected ? 2 : 0) + (repeatUseful ? 2 : 0) + (exactNeed ? 1 : 0) + (authority ? 1 : 0) - (riskScore * 2) - (desireLed ? 2 : 0) - (duplicate ? 2 : 0) - (cheapFinish ? 3 : 0) - (fitIssue ? 2 : 0);

      if (ownedMatch) {
        return jjOwnedClosetVerdict(ownedMatch);
      }

      if (!hasMeaningfulContext) {
        return { key: 'wait', confidence: 'High', action: 'Add context before buying', status: 'Verdict ready. The engine needs more signal.', text: 'Hold. A photo alone is not enough to justify a purchase. Add the occasion, the wardrobe gap, the price pressure, and what it replaces before calling this a buy.' };
      }

      if ((cheapFinish || (flashy && !event)) && !archiveIntent) {
        return { key: 'not_your_signal', confidence: 'High', action: 'Reject the purchase', status: 'Verdict ready. The engine is protecting the signal.', text: 'No. This is pulling attention without adding authority, ease, or long-term value. Replace it with a quieter, sharper version that relies on cut, material, and proportion.' };
      }

      if (fitIssue && (qualityScore || alignmentScore || exactNeed)) {
        return { key: 'tailor_first', confidence: immediate ? 'Medium' : 'High', action: 'Correct fit first', status: 'Verdict ready. The engine is prioritizing fit.', text: immediate ? 'Only proceed if the correction can happen before the event. The need may be real, but fit is still the difference between useful and expensive clutter.' : 'Not yet. The issue is structural, not emotional. Tailor the hem, waist, shoulder, sleeve, or repair before trusting the piece.' };
      }

      if (duplicate && qualityScore < 2 && !archiveIntent) {
        return { key: 'wait', confidence: 'High', action: 'Do not duplicate mediocrity', status: 'Verdict ready. The engine is skeptical.', text: 'Wait. Duplication without elevation is clutter. This needs a better material, better fit, or clearer role than what you already own.' };
      }

      if ((oneTime || desireLed) && !exactNeed && !wardrobeGap) {
        return { key: 'borrow_the_idea', confidence: 'Medium', action: 'Borrow the idea, not the item', status: 'Verdict ready. The engine sees short-use desire.', text: 'Use the styling idea, not the purchase. The reference may solve the mood, but the item itself has not earned permanent space in the wardrobe.' };
      }

      if (privateSource || (wardrobeGap && riskScore > 0)) {
        return { key: 'source_privately', confidence: 'Medium', action: 'Find the stronger version', status: 'Verdict ready. The need is real, but this version is not final.', text: 'The category may be right, but the version is not proven. Source privately for better cut, finish, fabric, and price discipline before buying.' };
      }

      if (archiveIntent) {
        return qualityScore >= 2 && riskScore <= 1
          ? { key: 'archive_worthy', confidence: 'High', action: 'Treat as long-term acquisition', status: 'Verdict ready. The engine sees archive potential.', text: 'This can be archive-worthy because the signal is in craft, rarity, or longevity rather than urgency. Buy for provenance and lasting value, not for a one-week thrill.' }
          : { key: 'source_privately', confidence: 'Medium', action: 'Do not call this archive yet', status: 'Verdict ready. The archive case needs a better piece.', text: 'The intention is strong, but this version has not earned investment status. Source the sharper option instead of forcing a maybe into the archive.' };
      }

      const buyReady = qualityScore >= 1 && alignmentScore >= 2 && (wardrobeConnected || repeatUseful || exactNeed || authority) && buyScore >= 5 && !cheapFinish && !fitIssue && !duplicate && !(desireLed && !exactNeed);

      if (buyReady) {
        return { key: 'buy_now', confidence: buyScore >= 7 ? 'High' : 'Medium', action: 'Buy with standards', status: 'Verdict ready. The engine sees enough proof.', text: 'Buy now only because the piece solves a real need, has enough quality, and can work beyond the first moment. Confirm fit, return window, and at least three outfit uses before checkout.' };
      }

      if (event && immediate) {
        return { key: 'source_privately', confidence: 'Medium', action: 'Solve the event without panic buying', status: 'Verdict ready. Urgency is not enough.', text: 'The event is real, but urgency alone is not a buy signal. Ask Jerry to source the cleanest option or use an existing piece unless this one proves fit, finish, and repeat use.' };
      }

      if (wardrobeGap || exactNeed) {
        return { key: 'source_privately', confidence: 'Medium', action: 'Route through private sourcing', status: 'Verdict ready. The category matters more than this exact item.', text: 'The need is real, but this piece has not proven it is the best answer. Source the stronger version before spending.' };
      }

      if (noRush || desireLed || riskScore > 0) {
        return { key: 'wait', confidence: desireLed ? 'High' : 'Medium', action: 'Pause and interrogate the impulse', status: 'Verdict ready. The engine is calling for restraint.', text: 'Wait. No deadline means no rush, and wanting it is not the same as needing it. Let price, fit, and wardrobe role become obvious before moving.' };
      }

      return { key: 'wait', confidence: 'Medium', action: 'Do not force a maybe into a yes', status: 'Verdict ready. The engine is unconvinced.', text: 'This has not earned the buy. If it cannot justify its role, finish, and difference from what you already own, it should stay under review.' };
    }

    function jjNormalizeDecisionValue(value) {
      const normalized = String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_');
      if (normalized.includes('event')) return 'event';
      if (normalized.includes('authority') || normalized.includes('leadership') || normalized.includes('client')) return 'authority';
      if (normalized.includes('investment') || normalized.includes('archive')) return 'investment';
      if (normalized.includes('wardrobe_gap') || normalized.includes('gap') || normalized.includes('missing')) return 'wardrobe_gap';
      if (normalized.includes('immediate') || normalized.includes('urgent') || normalized.includes('asap') || normalized.includes('this_week')) return 'immediate';
      if (normalized.includes('no_rush') || normalized.includes('not_urgent') || normalized.includes('later')) return 'no_rush';
      return normalized;
    }

    function normalizeRemoteVerdictKey(value) {
      const normalized = String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
      const aliases = {
        buy: 'buy_now',
        buy_now: 'buy_now',
        wait: 'wait',
        hold: 'wait',
        tailor: 'tailor_first',
        tailor_first: 'tailor_first',
        source: 'source_privately',
        source_private: 'source_privately',
        source_privately: 'source_privately',
        borrow: 'borrow_the_idea',
        borrow_the_idea: 'borrow_the_idea',
        borrow_the_idea_not_the_item: 'borrow_the_idea',
        archive: 'archive_worthy',
        archive_worthy: 'archive_worthy',
        not_your_signal: 'not_your_signal',
        reject: 'not_your_signal',
        no: 'not_your_signal'
      };
      return aliases[normalized] || 'wait';
    }

    function buildClosetSnapshot() {
      const items = Array.isArray(jjClientItems)
        ? jjClientItems
        : (Array.isArray(window.jjClientItems) ? window.jjClientItems : []);

      return items.slice(0, 80).map(function (item) {
        return {
          id: item.id || '',
          piece_type: item.piece_type || item.type || '',
          type: item.type || '',
          category: item.category || '',
          note: item.note || '',
          description: item.description || '',
          ai_description: item.ai_description || '',
          image_description: item.image_description || '',
          color: item.color || '',
          ai_color: item.ai_color || '',
          material: item.material || '',
          ai_material: item.ai_material || '',
          silhouette: item.silhouette || '',
          ai_silhouette: item.ai_silhouette || '',
          ai_details: item.ai_details || '',
          image_url: item.image_url || '',
          decision: item.decision || item.status || ''
        };
      });
    }

    function buildRemoteVerdictText(result) {
      const sections = [];

      if (result.rationale || result.reason) sections.push(result.rationale || result.reason);
      if (result.fit_notes) sections.push('Fit notes: ' + result.fit_notes);
      if (result.closet_impact) sections.push('Closet impact: ' + result.closet_impact);
      if (Array.isArray(result.risk_flags) && result.risk_flags.length) sections.push('Watchouts: ' + result.risk_flags.join('; '));
      if (Array.isArray(result.questions_for_jerry) && result.questions_for_jerry.length) sections.push('Questions: ' + result.questions_for_jerry.join('; '));
      if (result.next_step) sections.push('Next step: ' + result.next_step);

      return sections.join(' ');
    }

    function normalizeRemoteVerdict(result) {
      const key = normalizeRemoteVerdictKey(result && (result.verdict_key || result.key || result.verdict));
      const ownedMatch = jjFindOwnedClosetMatch();
      if (ownedMatch) {
        return jjOwnedClosetVerdict(ownedMatch);
      }
      const fallback = chooseVerdict();
      const card = verdictRoot.querySelector('.jj-verdictcard[data-key="' + key + '"]');
      const confidenceValue = result && result.confidence;
      const confidence = typeof confidenceValue === 'number'
        ? Math.round(confidenceValue * 100) + '%'
        : (confidenceValue || fallback.confidence || 'Medium');

      return {
        key: key,
        confidence: confidence,
        action: (result && (result.next_step || result.action)) || (card && card.getAttribute('data-title')) || fallback.action,
        status: (result && result.status) || (card && card.getAttribute('data-title')) || fallback.status,
        text: buildRemoteVerdictText(result || {}) || (result && result.text) || fallback.text
      };
    }

    async function requestRemoteVerdict() {
      const response = await fetch(remoteVerdictEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          piece: {
            fileName: uploadedFile ? uploadedFile.name : '',
            imageDataUrl: uploadedImageDataUrl,
            note: noteInput ? noteInput.value : '',
            goal: goalInput ? goalInput.value : '',
            urgency: urgencyInput ? urgencyInput.value : '',
            analysis: uploadedVision || null
          },
          context: {
            note: noteInput ? noteInput.value : '',
            goal: goalInput ? goalInput.value : '',
            urgency: urgencyInput ? urgencyInput.value : '',
            defaultVerdict: 'wait',
            closetRule: 'Always check the wardrobe rail first. If the uploaded candidate is the same as, or visually/descriptionally similar to, an active owned piece, return Wait and say the client already owns this or something very similar. Only reconsider if this version is limited edition, truly novel, or intentionally part of a collection.'
          },
          closet: buildClosetSnapshot(),
          client: window.JJ_CLIENT || client || {}
        })
      });

      if (!response.ok) throw new Error('Remote verdict engine returned ' + response.status);

      const data = await response.json();
      if (!data || data.ok === false) throw new Error((data && data.error) || 'Remote verdict engine failed');
      return normalizeRemoteVerdict(data);
    }

    async function chooseVerdictWithRemoteFallback() {
      try {
        if (statusEl) statusEl.textContent = 'Reading with Private Desk engine...';
        return await requestRemoteVerdict();
      } catch (error) {
        console.warn('Remote verdict engine unavailable. Using local fallback.', error);
        const fallback = chooseVerdict();
        return {
          ...fallback,
          status: fallback.status + ' Local fallback used because the remote engine was unavailable.'
        };
      }
    }

    function resizeVerdictImageDataUrl(dataUrl, maxSize, quality) {
      return new Promise(function (resolve) {
        if (!dataUrl || typeof Image === 'undefined' || typeof document === 'undefined') {
          resolve(dataUrl || '');
          return;
        }

        const img = new Image();
        img.onload = function () {
          const longestSide = Math.max(img.width || 0, img.height || 0);
          if (!longestSide || longestSide <= maxSize) {
            resolve(dataUrl);
            return;
          }

          const scale = maxSize / longestSide;
          const canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(img.width * scale));
          canvas.height = Math.max(1, Math.round(img.height * scale));
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            resolve(dataUrl);
            return;
          }
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL('image/jpeg', quality));
        };
        img.onerror = function () {
          resolve(dataUrl);
        };
        img.src = dataUrl;
      });
    }

    if (fileInput) {
      fileInput.addEventListener('change', function (event) {
        if (event.target.files && event.target.files[0]) {
          uploadedFile = event.target.files[0];
          uploadedImageDataUrl = '';
          uploadedVision = null;
          const reader = new FileReader();
          reader.onload = async function (readerEvent) {
            const originalImageDataUrl = readerEvent.target.result || '';
            uploadedImageDataUrl = originalImageDataUrl;
            setPreview(originalImageDataUrl);
            if (statusEl) statusEl.textContent = 'Image ready. Add context and run verdict.';
            uploadedImageDataUrl = await resizeVerdictImageDataUrl(originalImageDataUrl, 1400, 0.82);
            detectPieceType(uploadedImageDataUrl).then(function (analysis) {
              uploadedVision = analysis || null;
            }).catch(function (error) {
              console.warn('VERDICT VISION PREFLIGHT FAILED:', error);
            });
          };
          reader.readAsDataURL(uploadedFile);
        }
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        activateCard(card);
      });
    });

    if (runBtn) {
      runBtn.addEventListener('click', async function () {
        if (!uploadedFile) {
          if (statusEl) statusEl.textContent = 'Upload a piece first.';
          return;
        }

        runBtn.disabled = true;
        const originalButtonText = runBtn.textContent;
        runBtn.textContent = 'Reading...';

        try {
          if (!uploadedVision && uploadedImageDataUrl) {
            if (statusEl) statusEl.textContent = 'Checking your closet before verdict...';
            try {
              uploadedVision = await detectPieceType(uploadedImageDataUrl);
            } catch (error) {
              console.warn('VERDICT VISION CHECK FAILED:', error);
            }
          }
          const result = await chooseVerdictWithRemoteFallback();
          const match = verdictRoot.querySelector('.jj-verdictcard[data-key="' + result.key + '"]');
          activateCard(match);
          if (confidenceEl) confidenceEl.textContent = result.confidence;
          if (actionEl) actionEl.textContent = result.action;
          if (statusEl) statusEl.textContent = result.status;
          if (focusText) focusText.textContent = result.text;
          if (disagreeNote) {
            disagreeNote.textContent = result.action === 'Ask Jerry before buying'
              ? 'This is not a no. It is a review flag. Ask Jerry before buying so urgency does not create the wrong purchase.'
              : 'If you still believe in the piece, ask Jerry to defend it against the engine.';
          }
        } finally {
          runBtn.disabled = false;
          runBtn.textContent = originalButtonText;
        }
      });
    }

    if (askJerryBtn) {
      askJerryBtn.addEventListener('click', function () {
        const commandInput = byId('jj-command-input');
        const pieceName = uploadedFile ? uploadedFile.name : 'this piece';
        const text = 'I disagree with the Proprietary Engine verdict on ' + pieceName + '. Give me a stricter second opinion and tell me whether this strengthens my wardrobe, weakens my signal, or only works if tailored.';
        if (commandInput) commandInput.value = text;

        if (window.JJChat && window.JJChat.prefillAndOpen) {
          window.JJChat.prefillAndOpen(text);
        } else {
          jjOpenChatModal();
          const chatInput = byId('jj-chat-input');
          if (chatInput) chatInput.value = text;
        }

        if (statusEl) statusEl.textContent = 'Sent to Jerry for a second opinion.';
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        uploadedFile = null;
        uploadedImageDataUrl = '';
        uploadedVision = null;
        setPreview('');
        if (fileInput) fileInput.value = '';
        if (noteInput) noteInput.value = '';
        if (goalInput) goalInput.value = '';
        if (urgencyInput) urgencyInput.value = '';
        if (confidenceEl) confidenceEl.textContent = '—';
        if (actionEl) actionEl.textContent = 'Awaiting evaluation';
        if (statusEl) statusEl.textContent = 'Awaiting image upload.';
        if (disagreeNote) disagreeNote.textContent = 'If the verdict feels off, send it to Jerry for a second read.';
        if (defaultVerdictCard) activateCard(defaultVerdictCard);
      });
    }

    if (defaultVerdictCard) activateCard(defaultVerdictCard);
  }

  /* ===============================
     SUPABASE / CLOSET
  ================================ */

  const JJ_CLOSET_LIMIT = 500;
  const JJ_CLOSET_BUCKET = 'closet-images';
  const JJ_CLOSET_TABLE = 'client_closet_items';
  const JJ_PROFILE_TABLE = 'client_profiles';
  const JJ_GARMENT_CARE_TABLE = 'garment_care_jobs';
  const JJ_PROFILE_BUCKET = 'profile-uploads';

  let jjSupabase = null;
  let jjAuthUser = null;
  let jjClientItems = [];
  let jjGarmentCareJobs = [];
  const jjClosetSignedUrlCache = {};
  let jjWardrobeAccessLinkSent = false;

  async function jjInitSupabase() {
    if (jjSupabase) return jjSupabase;

    if (!window.JJ_SUPABASE_URL || !window.JJ_SUPABASE_ANON_KEY) {
      console.error('Missing Supabase settings. Add window.JJ_SUPABASE_URL and window.JJ_SUPABASE_ANON_KEY before jj-dashboard.js.');
      return null;
    }

    const mod = await import('https://cdn.jsdelivr.net/npm/@supabase/supabase-js/+esm');
    jjSupabase = mod.createClient(window.JJ_SUPABASE_URL, window.JJ_SUPABASE_ANON_KEY);
    return jjSupabase;
  }

  async function jjRequireAuthUser() {
    const supabase = await jjInitSupabase();
    if (!supabase) throw new Error('Supabase is not configured.');

    const result = await supabase.auth.getUser();
    if (result.error) throw result.error;
    if (!result.data || !result.data.user) {
      throw new Error('Please log in to access your private wardrobe.');
    }

    if (await jjClearMismatchedAuthSession(supabase, result.data.user)) {
      throw new Error(jjAuthMismatchMessage(result.data.user));
    }

    jjAuthUser = result.data.user;
    return jjAuthUser;
  }

  function jjSecureWardrobeMessage() {
    return 'Your client login is active, but secure wardrobe storage needs a private upload session. Use the secure access link for this client, then upload again.';
  }

  function jjNormalizeEmail(email) {
    return String(email || '').trim().toLowerCase();
  }

  function jjShopifyClientEmail() {
    return jjNormalizeEmail(window.JJ_CLIENT_EMAIL || client.email || '');
  }

  function jjAuthSessionMismatch(user) {
    const expectedEmail = jjShopifyClientEmail();
    const actualEmail = jjNormalizeEmail(user && user.email);
    return !!(expectedEmail && actualEmail && expectedEmail !== actualEmail);
  }

  function jjAuthMismatchMessage(user) {
    const expectedEmail = jjShopifyClientEmail();
    const actualEmail = jjNormalizeEmail(user && user.email);
    if (!expectedEmail || !actualEmail) return jjSecureWardrobeMessage();
    return 'This browser is still using the secure wardrobe session for ' + actualEmail + '. Use the secure access link for ' + expectedEmail + ', then upload again.';
  }

  async function jjClearMismatchedAuthSession(supabase, user) {
    if (!jjAuthSessionMismatch(user)) return false;
    try {
      await supabase.auth.signOut();
    } catch (error) {
      console.warn('Unable to clear mismatched wardrobe session:', error);
    }
    jjAuthUser = null;
    return true;
  }

  async function jjSendWardrobeAccessLink() {
    const email = jjClientEmail(null);
    if (!email || jjWardrobeAccessLinkSent) return false;

    const supabase = await jjInitSupabase();
    if (!supabase) return false;

    const result = await supabase.auth.signInWithOtp({
      email: email,
      options: {
        emailRedirectTo: window.location.origin + window.location.pathname
      }
    });

    if (result.error) throw result.error;

    jjWardrobeAccessLinkSent = true;
    return true;
  }

  async function jjGetOptionalAuthUser() {
    try {
      const supabase = await jjInitSupabase();
      if (!supabase) return null;
      const result = await supabase.auth.getUser();
      if (result.error || !result.data || !result.data.user) return null;
      if (await jjClearMismatchedAuthSession(supabase, result.data.user)) return null;
      jjAuthUser = result.data.user;
      return jjAuthUser;
    } catch (error) {
      return null;
    }
  }

  function jjConsentClient() {
    const email = window.JJ_CLIENT_EMAIL || client.email || null;
    const id = client.shopifyCustomerId || email || 'guest';
    return {
      id: String(id),
      email: email
    };
  }

  function jjClientOwnerId(user) {
    const fallback = client.shopifyCustomerId || window.JJ_CLIENT_EMAIL || client.email || 'guest';
    return String(user && user.id ? user.id : fallback).replace(/[^a-zA-Z0-9_-]/g, '-');
  }

  function jjClientEmail(user) {
    return jjNormalizeEmail((user && user.email) || window.JJ_CLIENT_EMAIL || client.email || null) || null;
  }

  function jjSupabaseOrValue(value) {
    return String(value || '').replace(/\\/g, '\\\\').replace(/,/g, '\\,').replace(/\)/g, '\\)').replace(/\(/g, '\\(');
  }

  function jjClosetIdentityFilter(user, includeShopify) {
    const filters = [];
    const email = jjClientEmail(user);

    if (user && user.id) filters.push('user_id.eq.' + jjSupabaseOrValue(user.id));
    if (email) filters.push('client_email.eq.' + jjSupabaseOrValue(email));
    if (includeShopify !== false && client.shopifyCustomerId) filters.push('shopify_customer_id.eq.' + jjSupabaseOrValue(client.shopifyCustomerId));

    return filters.join(',');
  }

  function jjShopifyColumnMissing(error) {
    return !!(error && /shopify_customer_id/i.test(error.message || ''));
  }

  window.jjInitSupabase = jjInitSupabase;
  window.jjRequireAuthUser = jjRequireAuthUser;

  function jjSetClosetStatus(message) {
    const status = byId('jj-droom-status') || byId('jj-closet-status');
    if (status) status.textContent = message || '';
  }

  function jjUpdateClosetCount() {
    const countEl = byId('jj-droom-count') || byId('jj-closet-count') || byId('jj-droom-stat-total');
    if (countEl) {
      countEl.textContent = String(jjClientItems.length);
    }
  }

  function jjRouteClosetContainer(pieceType) {
    const type = String(pieceType || '').toLowerCase();
    if (type === 'shoe' || type === 'shoes') return byId('jj-droom-shoes');
    if (type === 'bag' || type === 'bags') return byId('jj-droom-bags');
    if (['accessory', 'accessories', 'jewelry', 'watch', 'belt', 'eyewear', 'scarf'].includes(type)) return byId('jj-droom-accessories');
    return byId('jj-droom-garments');
  }

  function jjNormalizePieceType(type) {
    const clean = String(type || 'garment').trim().toLowerCase().replace(/[_-]+/g, ' ');
    if (['shoe', 'shoes'].includes(clean)) return 'shoe';
    if (['bag', 'bags'].includes(clean)) return 'bag';
    if (['accessory', 'accessories', 'jewelry', 'watch', 'belt', 'eyewear', 'sunglasses', 'scarf'].includes(clean)) return 'accessory';
    if (['jacket', 'blazer', 'coat', 'outerwear', 'trench', 'bomber', 'moto jacket', 'leather jacket', 'suiting', 'tailored layer'].includes(clean)) return 'outerwear';
    if (['shirt', 'blouse', 'tee', 't shirt', 't-shirt', 'sweater', 'knit', 'tank', 'vest', 'hoodie'].includes(clean)) return 'top';
    if (['pant', 'pants', 'trouser', 'trousers', 'jean', 'jeans', 'short', 'shorts', 'skirt', 'bottom'].includes(clean)) return 'bottom';
    if (['dress', 'gown'].includes(clean)) return 'dress';
    if (['top', 'bottom', 'dress', 'outerwear'].includes(clean)) return clean;
    return 'garment';
  }

  function jjInferPieceTypeFromVision(vision, fallback) {
    const text = [
      vision && vision.piece_type,
      vision && vision.description,
      vision && vision.color,
      vision && vision.material,
      vision && vision.silhouette,
      Array.isArray(vision && vision.details) ? vision.details.join(' ') : (vision && vision.details)
    ].filter(Boolean).join(' ').toLowerCase();

    if (/\b(blazer|jacket|coat|outerwear|trench|bomber|moto|parka|suiting|tailored layer)\b/.test(text)) return 'outerwear';
    return jjNormalizePieceType((vision && vision.piece_type) || fallback);
  }

  function jjPieceSearchText(item) {
    if (!item) return '';
    return [
      item.piece_type,
      item.note,
      item.ai_description,
      item.ai_color,
      item.ai_material,
      item.ai_silhouette,
      Array.isArray(item.ai_details) ? item.ai_details.join(' ') : item.ai_details
    ].filter(Boolean).join(' ').toLowerCase();
  }

  function jjIsBlazerOrJacket(item) {
    const text = jjPieceSearchText(item);
    return /\b(blazer|jacket|coat|suiting|tailored layer|outerwear)\b/.test(text);
  }

  function jjEffectiveSignalType(item) {
    if (jjIsBlazerOrJacket(item)) return 'outerwear';
    return jjNormalizePieceType(item && item.piece_type);
  }

  function jjRepairOuterwearClassifications(supabase, items) {
    if (!supabase || !Array.isArray(items)) return;

    items.forEach(function (item) {
      if (!item || !item.id || !jjIsBlazerOrJacket(item)) return;
      if (jjNormalizePieceType(item.piece_type) === 'outerwear') return;

      item.piece_type = 'outerwear';
      supabase
        .from(JJ_CLOSET_TABLE)
        .update({ piece_type: 'outerwear' })
        .eq('id', item.id)
        .then(function (result) {
          if (result && result.error) console.warn('OUTERWEAR CLASSIFICATION REPAIR FAILED:', result.error);
        });
    });
  }

  function jjGetClosetNote() {
    const note = byId('jj-droom-note') || byId('jj-closet-note');
    return note && note.value ? note.value.trim() : '';
  }

  function jjBuildStoragePath(file, userId) {
    const fileExt = String(file.name || 'jpg').split('.').pop().toLowerCase() || 'jpg';
    return `${userId}/${Date.now()}-${Math.random().toString(36).slice(2)}.${fileExt}`;
  }

  function jjIsHeicFile(file) {
    const name = String(file && file.name || '').toLowerCase();
    const type = String(file && file.type || '').toLowerCase();
    return type === 'image/heic' || type === 'image/heif' || type === '' && /\.(heic|heif)$/.test(name) || /\.(heic|heif)$/.test(name);
  }

  function jjImageFileName(file, extension) {
    const base = String(file && file.name || 'wardrobe-piece')
      .replace(/\.[^.]+$/, '')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/^-|-$/g, '') || 'wardrobe-piece';
    return base + '.' + extension;
  }

  function jjCanvasBlob(canvas, type, quality) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (blob) resolve(blob);
        else reject(new Error('Image compression failed.'));
      }, type, quality);
    });
  }

  async function jjCompressImageFile(file) {
    const type = String(file && file.type || '').toLowerCase();
    if (!file || !/^image\/(jpeg|jpg|png|webp)$/.test(type)) return file;
    if (file.size && file.size <= 6 * 1024 * 1024 && type !== 'image/png') return file;

    const objectUrl = URL.createObjectURL(file);
    try {
      const image = new Image();
      image.decoding = 'async';
      const loaded = new Promise(function (resolve, reject) {
        image.onload = resolve;
        image.onerror = function () { reject(new Error('Unable to prepare image for upload.')); };
      });
      image.src = objectUrl;
      await loaded;

      const maxSide = 1800;
      const scale = Math.min(1, maxSide / Math.max(image.naturalWidth || image.width, image.naturalHeight || image.height));
      const width = Math.max(1, Math.round((image.naturalWidth || image.width) * scale));
      const height = Math.max(1, Math.round((image.naturalHeight || image.height) * scale));
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d');
      if (!context) return file;
      context.drawImage(image, 0, 0, width, height);

      const blob = await jjCanvasBlob(canvas, 'image/jpeg', 0.82);
      return new File([blob], jjImageFileName(file, 'jpg'), {
        type: 'image/jpeg',
        lastModified: Date.now()
      });
    } finally {
      URL.revokeObjectURL(objectUrl);
    }
  }

  async function jjNormalizeUploadImage(file) {
    if (!jjIsHeicFile(file)) return jjCompressImageFile(file);

    try {
      let converter = window.heic2any;
      if (!window.heic2any) {
        const mod = await import('https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js');
        converter = window.heic2any || mod.default || mod.heic2any;
      }
      if (!converter) throw new Error('HEIC converter unavailable.');

      const converted = await converter({
        blob: file,
        toType: 'image/jpeg',
        quality: 0.88
      });
      const blob = Array.isArray(converted) ? converted[0] : converted;
      if (!blob) throw new Error('HEIC conversion returned no image.');

      const safeName = String(file.name || 'wardrobe-piece.heic').replace(/\.(heic|heif)$/i, '.jpg');
      return jjCompressImageFile(new File([blob], safeName, {
        type: 'image/jpeg',
        lastModified: Date.now()
      }));
    } catch (error) {
      console.error('HEIC CONVERSION ERROR:', error);
      throw new Error('This iPhone image needs to be converted before upload. Please choose JPEG, PNG, or WebP.');
    }
  }

  function jjClosetUploadInput() {
    return byId('jj-droom-upload')
      || document.querySelector('[data-jj-closet-upload-input]')
      || document.querySelector('#jj-dressing-room input[type="file"][accept*="image"]');
  }

  async function loadClosetItems() {
    try {
      jjSetClosetStatus('Loading wardrobe...');
      const supabase = await jjInitSupabase();
      const user = await jjGetOptionalAuthUser();

      if (!user || !user.id) {
        jjClientItems = [];
        window.jjClientItems = jjClientItems;
        renderCloset([]);
        jjUpdateSignalRoom([]);
        jjUpdateClosetCount();
        updateDressingRoomInsights();
        jjUpdateOperatingRail();
        jjSetClosetStatus(jjSecureWardrobeMessage());
        return;
      }

      const identityFilter = jjClosetIdentityFilter(user, true);
      if (!identityFilter) {
        jjClientItems = [];
        window.jjClientItems = jjClientItems;
        renderCloset([]);
        jjUpdateSignalRoom([]);
        jjUpdateClosetCount();
        updateDressingRoomInsights();
        jjUpdateOperatingRail();
        jjSetClosetStatus(jjSecureWardrobeMessage());
        return;
      }

      let result = await supabase
        .from(JJ_CLOSET_TABLE)
        .select('*')
        .or(identityFilter)
        .order('created_at', { ascending: false });

      if (jjShopifyColumnMissing(result.error)) {
        result = await supabase
          .from(JJ_CLOSET_TABLE)
          .select('*')
          .or(jjClosetIdentityFilter(user, false))
          .order('created_at', { ascending: false });
      }

      if (result.error) throw result.error;

      jjClientItems = result.data || [];
      jjRepairOuterwearClassifications(supabase, jjClientItems);
      window.jjClientItems = jjClientItems;
      jjPreloadClosetImages(jjClientItems);

      renderCloset(jjClientItems);
      jjUpdateSignalRoom(jjClientItems);
      jjUpdateClosetCount();
      updateDressingRoomInsights();
      jjUpdateOperatingRail();
      jjSetClosetStatus('');
    } catch (error) {
      console.error('LOAD CLOSET ERROR:', error);
      jjSetClosetStatus(error.message || 'Unable to load wardrobe.');
    }
  }

  async function runAuthorityRead(imageUrl) {
    try {
      const response = await fetch('https://jj-intelligence-engine.vercel.app/api/authority-read', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          image_url: imageUrl,
          client: window.JJ_CLIENT || { authority_role: 'AUTHORITY' }
        })
      });

      const result = await response.json();
      console.log('AUTHORITY RESULT:', result);
      return result;
    } catch (error) {
      console.error('AUTHORITY ERROR:', error);
      return null;
    }
  }

  async function detectPieceType(imageUrl) {
    try {
      const response = await fetch('https://jj-intelligence-engine.vercel.app/api/vision-analyze', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image_url: imageUrl })
      });

      const result = await response.json();
      console.log('VISION RESULT:', result);

      const vision = {
        piece_type: result.piece_type || 'accessory',
        confidence: result.confidence || 0,
        description: result.description || '',
        color: result.dominant_color || result.color || '',
        material: result.material || '',
        silhouette: result.silhouette || '',
        details: result.details || []
      };
      vision.piece_type = jjInferPieceTypeFromVision(vision, vision.piece_type);
      return vision;
    } catch (error) {
      console.error('VISION ERROR:', error);
      return {
        piece_type: 'accessory',
        confidence: 0,
        description: '',
        color: '',
        material: '',
        silhouette: '',
        details: []
      };
    }
  }

  function normalizePublicUrl(url) {
    let imageUrl = url || '';
    if (imageUrl && !imageUrl.includes('/public/')) {
      imageUrl = imageUrl.replace('/storage/v1/object/', '/storage/v1/object/public/');
    }
    if (imageUrl && imageUrl.startsWith('/storage')) {
      imageUrl = `${window.JJ_SUPABASE_URL}${imageUrl}`;
    }
    return imageUrl;
  }

  function jjBuildSupabaseThumbUrl(url, width, height) {
    const imageUrl = normalizePublicUrl(url);
    if (!imageUrl || imageUrl.indexOf('/storage/v1/object/public/') === -1) return imageUrl;

    const separator = imageUrl.indexOf('?') === -1 ? '?' : '&';
    return imageUrl
      .replace('/storage/v1/object/public/', '/storage/v1/render/image/public/')
      + separator
      + 'width=' + (width || 360)
      + '&height=' + (height || 460)
      + '&resize=cover&quality=72';
  }

  async function jjGetClosetSignedUrl(storagePath, width, height) {
    const path = String(storagePath || '').trim();
    if (!path) return '';

    const cacheKey = [path, width || 360, height || 460].join('|');
    if (jjClosetSignedUrlCache[cacheKey]) return jjClosetSignedUrlCache[cacheKey];

    const supabase = await jjInitSupabase();
    if (!supabase) return '';

    const result = await supabase.storage
      .from(JJ_CLOSET_BUCKET)
      .createSignedUrl(path, 3600, {
        transform: {
          width: width || 360,
          height: height || 460,
          resize: 'cover',
          quality: 72
        }
      });

    if (result.error) throw result.error;

    const signedUrl = result.data && result.data.signedUrl
      ? result.data.signedUrl
      : '';
    jjClosetSignedUrlCache[cacheKey] = signedUrl;
    return signedUrl;
  }

  window.jjRepairClosetImage = async function jjRepairClosetImage(img) {
    if (!img || img.dataset.jjRepairing === 'true') return;
    img.dataset.jjRepairing = 'true';

    try {
      const signedUrl = await jjGetClosetSignedUrl(img.dataset.storagePath, 360, 460);
      if (signedUrl) {
        img.src = signedUrl;
        img.dataset.jjRepairing = '';
        return;
      }
    } catch (error) {
      console.warn('SIGNED CLOSET IMAGE RETRY FAILED:', error);
    }

    const fullSrc = img.dataset.fullSrc || '';
    if (fullSrc && img.dataset.jjTriedFullSrc !== 'true' && img.src !== fullSrc) {
      img.dataset.jjTriedFullSrc = 'true';
      img.dataset.jjRepairing = '';
      img.src = fullSrc;
      return;
    }

    img.onerror = null;
    img.removeAttribute('src');
    img.alt = 'Wardrobe image unavailable';
    img.classList.add('is-unavailable');
    img.dataset.jjRepairing = '';
  };

  function jjPreloadClosetImages(items) {
    (items || []).slice(0, 10).forEach(function (item) {
      const src = jjBuildSupabaseThumbUrl(item.image_url, 360, 460);
      if (!src) return;
      const img = new Image();
      img.decoding = 'async';
      img.src = src;
    });
  }

  function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
      if (!file) {
        reject(new Error('Missing file.'));
        return;
      }

      const reader = new FileReader();
      reader.onload = function () {
        resolve(typeof reader.result === 'string' ? reader.result : '');
      };
      reader.onerror = function () {
        reject(reader.error || new Error('Unable to read file.'));
      };
      reader.readAsDataURL(file);
    });
  }

  function setAuthorityPreview(imageUrl, label) {
    const previewImage = byId('jjAuthorityPreviewImage');
    const previewPlaceholder = byId('jjAuthorityPreviewPlaceholder');
    const previewBadge = byId('jjAuthorityPreviewBadge');
    const uploadMeta = byId('jjAuthorityUploadMeta');
    const statusLine = byId('jjAuthorityStatusLine');
    const lightboxImage = byId('jjAuthorityLightboxImage');

    if (previewImage && imageUrl) {
      previewImage.src = imageUrl;
      previewImage.alt = label || 'Current Lead Look preview';
      previewImage.style.display = 'block';
    }
    if (previewPlaceholder) {
      previewPlaceholder.style.display = imageUrl ? 'none' : 'flex';
    }
    if (previewBadge) {
      previewBadge.textContent = 'Preview Ready';
    }
    if (uploadMeta && label) {
      uploadMeta.textContent = 'Selected: ' + label;
    }
    if (statusLine) {
      statusLine.textContent = imageUrl
        ? 'Look ready for review.'
        : 'Waiting for upload.';
    }
    if (lightboxImage && imageUrl) {
      lightboxImage.src = imageUrl;
    }
  }

  function applyAuthorityReadResult(result) {
    if (!result || typeof result !== 'object') return;

    const deskReadEl = byId('jjAuthorityReadCopy');
    const readStateEl = byId('jjAuthorityReadState');
    const lookSayingEl = byId('jjAuthorityLookMessage');
    const nextMoveEl = byId('jjAuthorityNextMove');
    const scoreValueEl = byId('jjAuthorityScoreValue');
    const scoreStateEl = byId('jjAuthorityScoreState');
    const readTimeEl = byId('jjAuthorityReadTime');
    const roomStampEl = byId('jjAuthorityRoomStamp');
    const statusLineEl = byId('jjAuthorityStatusLine');

    if (readStateEl) readStateEl.textContent = result.label || 'Active';
    if (scoreValueEl) scoreValueEl.textContent = result.score || '--';
    if (scoreStateEl) scoreStateEl.textContent = result.label || 'Evaluated';
    if (deskReadEl) deskReadEl.textContent = result.desk_read || result.verdict || result.read || "This isn't fully resolved yet.";
    if (lookSayingEl) lookSayingEl.textContent = result.what_the_look_is_saying || result.working || result.message || "There's something here. It just isn't fully working yet.";
    if (nextMoveEl) nextMoveEl.textContent = result.next_move || result.recommendation || result.action || 'Tighten this up.';
    if (readTimeEl) {
      readTimeEl.textContent = 'Reviewed ' + new Date().toLocaleString([], {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
      });
    }
    if (roomStampEl) roomStampEl.textContent = 'Desk Read Complete';
    if (statusLineEl) statusLineEl.textContent = 'Read complete.';
  }

  function setAuthorityReadError() {
    const deskReadEl = byId('jjAuthorityReadCopy');
    const lookSayingEl = byId('jjAuthorityLookMessage');
    const nextMoveEl = byId('jjAuthorityNextMove');
    const readStateEl = byId('jjAuthorityReadState');
    const roomStampEl = byId('jjAuthorityRoomStamp');
    const statusLineEl = byId('jjAuthorityStatusLine');

    if (deskReadEl) deskReadEl.textContent = 'Unable to read this look right now.';
    if (lookSayingEl) lookSayingEl.textContent = '';
    if (nextMoveEl) nextMoveEl.textContent = '';
    if (readStateEl) readStateEl.textContent = 'Read Unavailable';
    if (roomStampEl) roomStampEl.textContent = 'Read Failed';
    if (statusLineEl) statusLineEl.textContent = 'Unable to complete the read right now.';
  }

  async function uploadClosetItem(file, pieceType, note) {
    const supabase = await jjInitSupabase();
    if (!supabase) {
      jjSetClosetStatus('Supabase is not configured.');
      return;
    }
    let user = null;
    try {
      user = await jjRequireAuthUser();
    } catch (error) {
      console.warn('Missing Supabase wardrobe session:', error);
      let message = jjSecureWardrobeMessage();
      try {
        const sent = await jjSendWardrobeAccessLink();
        if (sent) {
          message = 'Secure wardrobe link sent to ' + jjClientEmail(null) + '. Open that link, then upload again.';
        }
      } catch (linkError) {
        console.error('WARDROBE ACCESS LINK ERROR:', linkError);
      }
      jjSetClosetStatus(message);
      alert(message);
      return;
    }
    if (!user || !user.id) {
      jjSetClosetStatus(jjSecureWardrobeMessage());
      return;
    }
    if (!file) return;

    if (jjClientItems.length >= JJ_CLOSET_LIMIT) {
      alert('Your private wardrobe is currently at capacity. Please remove pieces before adding more.');
      return;
    }

    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
    if (file.type && !allowedTypes.includes(file.type)) {
      alert('Please upload an image file.');
      return;
    }

    jjSetClosetStatus('Uploading piece...');

    const uploadFile = await jjNormalizeUploadImage(file);
    const filePath = jjBuildStoragePath(uploadFile, user.id);
    const uploadResult = await supabase.storage
      .from(JJ_CLOSET_BUCKET)
      .upload(filePath, uploadFile, { cacheControl: '3600', upsert: false, contentType: uploadFile.type || 'image/jpeg' });

    if (uploadResult.error) {
      const message = uploadResult.error.message || 'Upload failed.';
      console.error('UPLOAD ERROR:', uploadResult.error);
      jjSetClosetStatus('Upload failed: ' + message);
      alert('Upload failed: ' + message);
      return;
    }

    const publicData = supabase.storage.from(JJ_CLOSET_BUCKET).getPublicUrl(filePath).data;
    const imageUrl = normalizePublicUrl(publicData.publicUrl);
    const clientEmail = jjClientEmail(user);
    const recordId = window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : null;

    const closetPayload = {
      client_email: clientEmail ? String(clientEmail).toLowerCase() : null,
      shopify_customer_id: client.shopifyCustomerId ? String(client.shopifyCustomerId) : null,
      image_url: imageUrl,
      storage_path: filePath,
      piece_type: pieceType ? jjNormalizePieceType(pieceType) : 'unknown',
      ai_confidence: null,
      ai_description: null,
      ai_color: null,
      ai_material: null,
      ai_silhouette: null,
      ai_details: null,
      note: note || '',
      status: 'active'
    };

    if (recordId) {
      closetPayload.id = recordId;
    }

    if (user && user.id) {
      closetPayload.user_id = user.id;
    }

    let insertResult = await supabase.from(JJ_CLOSET_TABLE).insert([closetPayload]);

    if (jjShopifyColumnMissing(insertResult.error)) {
      const fallbackPayload = Object.assign({}, closetPayload);
      delete fallbackPayload.shopify_customer_id;
      insertResult = await supabase.from(JJ_CLOSET_TABLE).insert([fallbackPayload]);
    }

    if (insertResult.error) throw insertResult.error;

    await loadClosetItems();
    jjSetClosetStatus('Piece added. Reading details...');

    void (async function enrichClosetItem() {
      let vision = null;
      try {
        vision = await Promise.race([
          detectPieceType(imageUrl),
          new Promise(function (_, reject) {
            setTimeout(function () { reject(new Error('VISION TIMEOUT')); }, 5000);
          })
        ]);
      } catch (err) {
        console.error('VISION FAILED:', err);
      }

      if (vision && recordId) {
        const aiPieceType = jjInferPieceTypeFromVision(vision, closetPayload.piece_type);
        const updateResult = await supabase
          .from(JJ_CLOSET_TABLE)
          .update({
            piece_type: aiPieceType,
            ai_confidence: vision.confidence || null,
            ai_description: vision.description || null,
            ai_color: vision.color || null,
            ai_material: vision.material || null,
            ai_silhouette: vision.silhouette || null,
            ai_details: vision.details || null
          })
          .eq('id', recordId);
        if (updateResult.error) {
          console.error('VISION UPDATE FAILED:', updateResult.error);
        } else {
          await loadClosetItems();
        }
      }

      jjSetClosetStatus('Piece added.');
    })();

    const uploadInput = jjClosetUploadInput();
    const noteInput = byId('jj-droom-note') || byId('jj-closet-note');
    if (uploadInput) uploadInput.value = '';
    if (noteInput) noteInput.value = '';
  }

  async function deleteClosetItem(item) {
    try {
      const supabase = await jjInitSupabase();
      const user = await jjRequireAuthUser();
      if (!item || !item.id) return;
      if (!confirm('Remove this piece from your private wardrobe?')) return;

      jjSetClosetStatus('Removing piece...');

      const identityFilter = jjClosetIdentityFilter(user, true);
      let deleteQuery = supabase
        .from(JJ_CLOSET_TABLE)
        .delete()
        .eq('id', item.id);

      if (identityFilter) deleteQuery = deleteQuery.or(identityFilter);

      const dbResult = await deleteQuery;

      if (dbResult.error) throw dbResult.error;

      if (item.storage_path) {
        await supabase.storage.from(JJ_CLOSET_BUCKET).remove([item.storage_path]);
      }

      await loadClosetItems();
      jjSetClosetStatus('Piece removed.');
    } catch (error) {
      console.error('DELETE CLOSET ERROR:', error);
      jjSetClosetStatus(error.message || 'Unable to remove piece.');
    }
  }

  async function updatePieceType(id, pieceType) {
    try {
      const supabase = await jjInitSupabase();
      const user = await jjRequireAuthUser();
      if (!id || !pieceType) return;

      jjSetClosetStatus('Moving piece...');

      const identityFilter = jjClosetIdentityFilter(user, true);
      let updateQuery = supabase
        .from(JJ_CLOSET_TABLE)
        .update({ piece_type: jjNormalizePieceType(pieceType) })
        .eq('id', id);

      if (identityFilter) updateQuery = updateQuery.or(identityFilter);

      const result = await updateQuery;

      if (result.error) throw result.error;
      await loadClosetItems();
      jjSetClosetStatus('Piece moved.');
    } catch (error) {
      console.error('UPDATE PIECE TYPE ERROR:', error);
      jjSetClosetStatus(error.message || 'Unable to move piece.');
    }
  }

  async function updateItemStatus(id, status) {
    try {
      const supabase = await jjInitSupabase();
      const user = await jjRequireAuthUser();
      if (!id || !status) return;

      jjSetClosetStatus('Updating piece...');

      const identityFilter = jjClosetIdentityFilter(user, true);
      let updateQuery = supabase
        .from(JJ_CLOSET_TABLE)
        .update({ status: status })
        .eq('id', id);

      if (identityFilter) updateQuery = updateQuery.or(identityFilter);

      const result = await updateQuery;

      if (result.error) throw result.error;
      await loadClosetItems();
      jjSetClosetStatus('Updated.');
    } catch (error) {
      console.error('UPDATE ITEM STATUS ERROR:', error);
      jjSetClosetStatus(error.message || 'Unable to update item.');
    }
  }

  function renderCloset(items) {
    const garments = byId('jj-droom-garments');
    const shoes = byId('jj-droom-shoes');
    const bags = byId('jj-droom-bags');
    const accessories = byId('jj-droom-accessories');
    const approvalBuckets = [
      byId('jj-droom-bucket-keep'),
      byId('jj-droom-bucket-tailor'),
      byId('jj-droom-bucket-release'),
      byId('jj-droom-bucket-consign')
    ].filter(Boolean);
    if (!garments) return;

    [garments, shoes, bags, accessories].filter(Boolean).forEach(function (el) {
      el.innerHTML = '';
    });
    approvalBuckets.forEach(function (bucket) {
      bucket.querySelectorAll('.jj-droom__piece').forEach(function (piece) {
        piece.remove();
      });
      jjSyncBucketEmpty(bucket);
    });

    if (!items || !items.length) {
      garments.innerHTML = '<div class="jj-empty">Your private wardrobe is ready. Upload your first piece.</div>';
      return;
    }

    items.forEach(function (item) {
      const card = document.createElement('div');
      card.className = 'jj-closet-card jj-droom__piece';
      card.setAttribute('data-piece-id', item.id);
      card.setAttribute('data-piece-type', jjEffectiveSignalType(item));
      card.setAttribute('data-piece-note', item.note || item.piece_type || 'Wardrobe piece');
      card.setAttribute('draggable', 'false');

      const status = item.status || 'active';
      const fixedUrl = normalizePublicUrl(item.image_url);
      const thumbUrl = jjBuildSupabaseThumbUrl(fixedUrl, 360, 460);

      card.innerHTML = `
        <div class="jj-closet-card__img jj-droom__pieceMedia">
          <img
            src="${jjEscapeHtml(thumbUrl)}"
            data-full-src="${jjEscapeHtml(fixedUrl)}"
            data-storage-path="${jjEscapeHtml(item.storage_path || '')}"
            alt="${jjEscapeHtml(item.piece_type || 'Wardrobe piece')}"
            loading="lazy"
            decoding="async"
            crossorigin="anonymous"
            referrerpolicy="no-referrer"
            onerror="window.jjRepairClosetImage&&window.jjRepairClosetImage(this);"
          />
        </div>
        <div class="jj-closet-card__meta jj-droom__pieceBody">
          <span class="jj-droom__pieceType">${jjEscapeHtml(jjEffectiveSignalType(item) || 'garment')}</span>
          <small>${jjEscapeHtml(status)}</small>
        </div>
        ${item.note ? `<div class="jj-closet-card__note jj-droom__pieceNote">${jjEscapeHtml(item.note)}</div>` : ''}
        <div class="jj-closet-card__actions">
          <button type="button" class="jj-status-btn" data-status="keep">Keep</button>
          <button type="button" class="jj-status-btn" data-status="tailor">Tailor</button>
          <button type="button" class="jj-status-btn" data-status="release">Release</button>
          <button type="button" class="jj-status-btn" data-status="consign">Consign</button>
          <button type="button" class="jj-status-btn" data-status="archive">Archive</button>
          <button type="button" class="jj-delete-btn">Remove</button>
          <select class="jj-closet-card__move" aria-label="Move piece">
            <option value="">Move to...</option>
            <option value="top">Wardrobe Rail</option>
            <option value="shoe">Shoe Shelf</option>
            <option value="bag">Bag Shelf</option>
            <option value="accessory">Accessory Tray</option>
          </select>
        </div>
      `;

      card.addEventListener('click', function (event) {
        if (event.target.closest('button') || event.target.closest('select')) return;
        openPieceDecision(card, item);
      });

      card.querySelectorAll('.jj-status-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          updateItemStatus(item.id, btn.getAttribute('data-status'));
        });
      });

      const deleteBtn = card.querySelector('.jj-delete-btn');
      if (deleteBtn) {
        deleteBtn.addEventListener('click', function () {
          deleteClosetItem(item);
        });
      }

      const moveSelect = card.querySelector('.jj-closet-card__move');
      if (moveSelect) {
        moveSelect.addEventListener('change', function (event) {
          event.stopPropagation();
          const newType = event.target.value;
          if (!newType) return;
          updatePieceType(item.id, newType);
        });
      }

      const approvalBucket = jjApprovalBucketForStatus(status);
      const container = approvalBucket || jjRouteClosetContainer(jjEffectiveSignalType(item));
      if (container) {
        container.appendChild(card);
        if (approvalBucket) jjSyncBucketEmpty(approvalBucket);
      } else {
        garments.appendChild(card);
      }
    });

    approvalBuckets.forEach(jjSyncBucketEmpty);
    updateDressingRoomInsights();
  }

  function openPieceDecision(piece, item) {
    if (!piece || !item) return;
    const modal = jjEnsurePieceDecisionModal();
    const img = piece.querySelector('img');
    const type = jjEffectiveSignalType(item);
    const status = item.status || 'active';

    modal.querySelector('.jj-piece-decision__image').innerHTML = img
      ? `<img src="${jjEscapeHtml(img.src)}" alt="${jjEscapeHtml(img.alt || 'Wardrobe piece')}">`
      : '<div class="jj-piece-decision__empty">Wardrobe Piece</div>';
    modal.querySelector('.jj-piece-decision__type').textContent = type || 'garment';
    modal.querySelector('.jj-piece-decision__status').textContent = status === 'active' ? 'Awaiting decision' : status;
    modal.querySelector('.jj-piece-decision__note').textContent = item.note || 'Choose where this piece belongs or place it into the styling mirror.';

    modal.querySelectorAll('[data-piece-decision]').forEach(function (btn) {
      btn.onclick = async function () {
        const decision = btn.getAttribute('data-piece-decision');
        if (decision === 'mirror') {
          closePieceDecision();
          routePieceToMirror(piece);
          buildSignalLook({ anchorId: item.id });
          return;
        }

        if (decision === 'remove') {
          closePieceDecision();
          deleteClosetItem(item);
          return;
        }

        closePieceDecision();
        await updateItemStatus(item.id, decision);
      };
    });

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('jj-no-scroll');
    document.body.classList.add('jj-no-scroll');
  }

  function jjEnsurePieceDecisionModal() {
    let modal = byId('jj-piece-decision-modal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'jj-piece-decision-modal';
    modal.className = 'jj-piece-decision';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
      <div class="jj-piece-decision__scrim" data-piece-close></div>
      <div class="jj-piece-decision__panel" role="dialog" aria-modal="true" aria-label="Wardrobe piece decision">
        <button type="button" class="jj-piece-decision__close" data-piece-close aria-label="Close">x</button>
        <div class="jj-piece-decision__scanline"></div>
        <div class="jj-piece-decision__grid">
          <div class="jj-piece-decision__image"></div>
          <div class="jj-piece-decision__content">
            <div class="jj-piece-decision__eyebrow">Piece Read</div>
            <h3>Choose the move</h3>
            <div class="jj-piece-decision__meta">
              <span class="jj-piece-decision__type"></span>
              <span class="jj-piece-decision__status"></span>
            </div>
            <p class="jj-piece-decision__note"></p>
            <div class="jj-piece-decision__actions">
              <button type="button" class="jj-piece-decision__primary" data-piece-decision="mirror">Build Look Around This Piece</button>
              <button type="button" data-piece-decision="keep">Keep</button>
              <button type="button" data-piece-decision="tailor">Tailor</button>
              <button type="button" data-piece-decision="release">Release</button>
              <button type="button" data-piece-decision="consign">Consign</button>
              <button type="button" data-piece-decision="archive">Archive</button>
            </div>
            <button type="button" class="jj-piece-decision__remove" data-piece-decision="remove">Remove piece</button>
          </div>
        </div>
      </div>
    `;

    modal.querySelectorAll('[data-piece-close]').forEach(function (btn) {
      btn.addEventListener('click', closePieceDecision);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closePieceDecision();
      }
    });

    document.body.appendChild(modal);
    return modal;
  }

  function closePieceDecision() {
    const modal = byId('jj-piece-decision-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('jj-no-scroll');
    document.body.classList.remove('jj-no-scroll');
  }

  function jjApprovalBucketForStatus(status) {
    const normalizedStatus = String(status || '').toLowerCase();
    if (!['keep', 'tailor', 'release', 'consign'].includes(normalizedStatus)) return null;
    return byId('jj-droom-bucket-' + normalizedStatus);
  }

  function jjSyncBucketEmpty(bucket) {
    if (!bucket) return;
    const empty = bucket.querySelector('.jj-droom__bucketEmpty');
    if (!empty) return;
    const hasPieces = !!bucket.querySelector('.jj-droom__piece');
    empty.style.display = hasPieces ? 'none' : '';
  }

  function initPrivateDeskSignalRoom() {
    if (byId('jj-private-signal-room')) return;

    const dressingRoom = byId('jj-dressing-room');
    if (!dressingRoom || !dressingRoom.parentNode) return;

    const module = document.createElement('section');
    module.id = 'jj-private-signal-room';
    module.className = 'jj-signalroom jj-reveal';
    module.innerHTML = `
      <div class="jj-signalroom__scanbeam"></div>
      <div class="jj-signalroom__main">
        <div>
          <p class="jj-signalroom__eyebrow">THE PRIVATE DESK WARDROBE MANAGER</p>
          <h2>YOUR WARDROBE.<br>WITH BETTER JUDGMENT.</h2>
          <p class="jj-signalroom__copy">Private Desk is reading your wardrobe signal, identifying weak categories, building a lead look, and flagging what to keep, tailor, release, consign, or source.</p>
        </div>
        <div class="jj-signalroom__score" aria-label="Wardrobe intelligence score">
          <span>Wardrobe Signal</span>
          <strong id="jjSignalScore">--%</strong>
          <em id="jjSignalState">Awaiting closet read</em>
        </div>
      </div>
      <div class="jj-signalroom__steps" aria-label="Private Desk status">
        <span class="is-active">Closet Intelligence Live</span>
        <span>Care + Tracking Synced</span>
        <span>Ready For Jerry Review</span>
      </div>
      <div class="jj-signalroom__readout">
        <div>
          <span>Strongest Category</span>
          <strong id="jjSignalStrongest">Reading</strong>
        </div>
        <div>
          <span>Weakest Category</span>
          <strong id="jjSignalWeakest">Reading</strong>
        </div>
        <div>
          <span id="jjSignalMoveLabel">Estimated Closet Investment</span>
          <strong id="jjSignalMove">Awaiting pieces</strong>
        </div>
      </div>
      <div class="jj-signalroom__jerry">
        <span id="jjSignalAi">AI scan standing by</span>
        <span id="jjSignalJerry">Jerry approval pending</span>
        <span id="jjSignalPrivate">Private recommendation ready</span>
        <button type="button" id="jjSignalScanBtn">Run Signal Scan</button>
      </div>
    `;

    const dashboard = document.querySelector('.jj-dashboard');
    const priorityCard = document.querySelector('.jj-prioritycard');
    if (dashboard) {
      dashboard.insertBefore(module, dashboard.firstElementChild || null);
    } else if (priorityCard && priorityCard.parentNode) {
      priorityCard.parentNode.insertBefore(module, priorityCard);
    } else {
      dressingRoom.parentNode.insertBefore(module, dressingRoom);
    }
    module.classList.add('is-in');

    const steps = Array.prototype.slice.call(module.querySelectorAll('.jj-signalroom__steps span'));
    let activeIndex = 0;
    window.setInterval(function () {
      if (!steps.length) return;
      steps.forEach(function (step) {
        step.classList.remove('is-active');
      });
      activeIndex = (activeIndex + 1) % steps.length;
      steps[activeIndex].classList.add('is-active');
    }, 1650);

    const scanBtn = byId('jjSignalScanBtn');
    if (scanBtn) {
      scanBtn.addEventListener('click', function () {
        dressingRoom.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const buildLookBtn = byId('jj-droom-build-look');
        if (buildLookBtn) {
          window.setTimeout(function () {
            buildLookBtn.click();
          }, 450);
        }
      });
    }

    jjUpdateSignalRoom(jjClientItems || []);
  }

  function jjSetSignalScanState(state) {
    const module = byId('jj-private-signal-room');
    if (!module) return;
    module.classList.toggle('is-scanning', state === 'scanning');
    module.classList.toggle('is-complete', state === 'complete');

    const ai = byId('jjSignalAi');
    const jerry = byId('jjSignalJerry');
    const privateRead = byId('jjSignalPrivate');
    if (state === 'scanning') {
      if (ai) ai.textContent = 'AI scan in motion';
      if (jerry) jerry.textContent = 'Jerry layer preparing read';
      if (privateRead) privateRead.textContent = 'Lead look assembling';
      return;
    }

    if (state === 'complete') {
      if (ai) ai.textContent = 'AI scan complete';
      if (jerry) jerry.textContent = 'Jerry approval pending';
      if (privateRead) privateRead.textContent = 'Private recommendation ready';
    }
  }

  function jjUpdateSignalRoom(items) {
    const module = byId('jj-private-signal-room');
    if (!module) return;

    const closetItems = items || [];
    const activeItems = closetItems.filter(function (item) {
      return !['archive'].includes(String(item.status || '').toLowerCase());
    });
    const categories = ['garment', 'top', 'bottom', 'dress', 'outerwear', 'shoe', 'bag', 'accessory'];
    const counts = categories.reduce(function (acc, category) {
      acc[category] = activeItems.filter(function (item) {
        return jjEffectiveSignalType(item) === category;
      }).length;
      return acc;
    }, {});

    const total = activeItems.length;
    const represented = categories.filter(function (category) {
      return counts[category] > 0;
    }).length;
    const approvalMoves = closetItems.filter(function (item) {
      return ['keep', 'tailor', 'release', 'consign'].includes(String(item.status || '').toLowerCase());
    }).length;
    const signalScore = total
      ? Math.max(48, Math.min(96, Math.round(42 + represented * 7 + Math.min(total, 18) * 1.8 + approvalMoves * 2)))
      : 0;

    const strongest = categories.slice().sort(function (a, b) {
      return counts[b] - counts[a];
    })[0];
    const weakest = categories.find(function (category) {
      return counts[category] === 0;
    }) || categories.slice().sort(function (a, b) {
      return counts[a] - counts[b];
    })[0];
    const closetValue = jjEstimateWardrobeValue(activeItems);

    const scoreEl = byId('jjSignalScore');
    const stateEl = byId('jjSignalState');
    const strongestEl = byId('jjSignalStrongest');
    const weakestEl = byId('jjSignalWeakest');
    const moveEl = byId('jjSignalMove');

    if (scoreEl) scoreEl.textContent = signalScore ? signalScore + '%' : '--%';
    if (stateEl) stateEl.textContent = total ? 'Live closet read' : 'Awaiting wardrobe upload';
    if (strongestEl) strongestEl.textContent = total ? jjTitleCase(strongest) : 'Pending';
    if (weakestEl) weakestEl.textContent = total ? jjTitleCase(weakest) : 'Pending';
    if (moveEl) moveEl.textContent = total ? closetValue.label : 'Awaiting pieces';
  }

  function jjEstimateWardrobeValue(items) {
    const activeItems = (items || []).filter(Boolean);
    if (!activeItems.length) return { low: 0, high: 0, label: '$--' };

    const baseRanges = {
      garment: [450, 1400],
      top: [280, 900],
      bottom: [350, 1200],
      dress: [650, 2400],
      outerwear: [950, 3800],
      shoe: [500, 1400],
      bag: [1200, 4200],
      accessory: [250, 1200],
      unknown: [350, 1000]
    };

    let low = 0;
    let high = 0;

    activeItems.forEach(function (item) {
      const type = jjEffectiveSignalType(item);
      const range = baseRanges[type] || baseRanges.unknown;
      const text = jjPieceSearchText(item);
      let multiplier = 1;
      let itemLow = range[0];
      let itemHigh = range[1];

      const isBag = type === 'bag';
      const isAccessory = type === 'accessory';
      const exoticMaterial = /\b(crocodile|croc|alligator|gator|python|snake|snakeskin|lizard|ostrich|eel|mink|sable|fur|exotic skin|exotic leather)\b/.test(text);
      const majorHermesBag = isBag && /\b(hermes|hermès|birkin|kelly|constance)\b/.test(text);
      const fineJewelry = isAccessory && /\b(almasika|sidney|sydney|cartier|van cleef|vca|bulgari|boucheron|tiffany|diamond|diamonds|18k|14k|gold|platinum|sapphire|emerald|ruby|fine jewelry)\b/.test(text);

      if (isBag && exoticMaterial) {
        itemLow = Math.max(itemLow, 10000);
        itemHigh = Math.max(itemHigh, 18000);
      }

      if (majorHermesBag) {
        itemLow = Math.max(itemLow, 12000);
        itemHigh = Math.max(itemHigh, exoticMaterial ? 45000 : 24000);
      }

      if (fineJewelry) {
        itemLow = Math.max(itemLow, 2500);
        itemHigh = Math.max(itemHigh, 15000);
      }

      if (/\b(cashmere|silk|leather|suede|shearling|alpaca|mohair|wool|linen|lace|beaded|embellished|handmade|couture)\b/.test(text)) multiplier += .18;
      if (/\b(chanel|hermes|hermès|dior|louis vuitton|vuitton|gucci|prada|saint laurent|ysl|bottega|celine|céline|loewe|fendi|valentino|balenciaga|balmain|brunello|loro piana|the row|khaite)\b/.test(text)) multiplier += .55;
      if (/\b(brandon maxwell|deveaux|twp|toteme|ulla johnson|zimmermann|staud|ganni|spanx|vince|theory|rag & bone|helmut lang)\b/.test(text)) multiplier += .25;
      if (/\b(vintage|rare|runway|archive|limited|designer|label visible|logo|monogram)\b/.test(text)) multiplier += .15;
      if (/\b(sale|dupe|zara|hm|h&m|target|amazon|shein|fashion nova)\b/.test(text)) multiplier -= .35;

      multiplier = Math.max(.55, Math.min(multiplier, 2.1));
      low += itemLow * multiplier;
      high += itemHigh * multiplier;
    });

    return {
      low: Math.round(low),
      high: Math.round(high),
      label: jjFormatCurrencyRange(low, high)
    };
  }

  function jjFormatCurrencyRange(low, high) {
    const lowK = Math.max(1, Math.round(Number(low || 0) / 1000));
    const highK = Math.max(lowK, Math.round(Number(high || 0) / 1000));
    return '$' + lowK + 'K-$' + highK + 'K';
  }

  function jjReadablePieceName(item) {
    const note = String(item && item.note ? item.note : '').trim();
    if (note) return note.split(',')[0].slice(0, 32);
    return jjTitleCase(jjNormalizePieceType(item && item.piece_type));
  }

  function jjTitleCase(value) {
    return String(value || '')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, function (letter) {
        return letter.toUpperCase();
      });
  }

  function initClosetUploadHandler() {
    const uploadInput = jjClosetUploadInput();
    if (!uploadInput || uploadInput.dataset.jjUploadBound === 'true') return;
    uploadInput.dataset.jjUploadBound = 'true';

    const handleFiles = async function (fileList) {
      const files = Array.prototype.slice.call(fileList || []);
      if (!files.length) return;

      jjSetClosetStatus(files.length === 1 ? 'Preparing upload: ' + (files[0].name || 'selected image') + '...' : 'Preparing ' + files.length + ' uploads...');
      const note = jjGetClosetNote();
      for (const file of files) {
        try {
          await uploadClosetItem(file, null, note);
        } catch (error) {
          console.error('CLOSET UPLOAD HANDLER ERROR:', error);
          const message = error.message || 'Unable to upload piece.';
          jjSetClosetStatus(message);
          alert(message);
        }
      }
    };

    uploadInput.addEventListener('change', function (event) {
      handleFiles(event.target.files);
    });

    const dropzone = byId('jj-droom-dropzone')
      || document.querySelector('label[for="jj-droom-upload"]')
      || document.querySelector('#jj-dressing-room [data-jj-closet-upload-trigger]')
      || document.querySelector('#jj-dressing-room .jj-droom__dropzone');
    if (!dropzone || dropzone.dataset.jjUploadTriggerBound === 'true') return;
    dropzone.dataset.jjUploadTriggerBound = 'true';

    const openUploadPicker = function (event) {
      if (event) event.preventDefault();
      if (typeof uploadInput.showPicker === 'function') {
        try {
          uploadInput.showPicker();
          return;
        } catch (error) {
          /* Fall back to click for browsers that gate showPicker. */
        }
      }
      uploadInput.click();
    };

    if (dropzone.tagName.toLowerCase() !== 'label') {
      dropzone.addEventListener('click', openUploadPicker);
    }

    dropzone.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        openUploadPicker(event);
      }
    });

    dropzone.addEventListener('dragover', function (event) {
      event.preventDefault();
      dropzone.classList.add('is-dragover');
    });

    dropzone.addEventListener('dragleave', function () {
      dropzone.classList.remove('is-dragover');
    });

    dropzone.addEventListener('drop', function (event) {
      event.preventDefault();
      dropzone.classList.remove('is-dragover');
      handleFiles(event.dataTransfer && event.dataTransfer.files);
    });
  }

  function initAuthorityRead() {
    const fileInput = byId('jjAuthorityFile');
    const runBtn = byId('jjAuthorityRunBtn');
    const resetBtn = byId('jjAuthorityResetBtn');
    const expandBtn = byId('jjAuthorityExpandBtn');
    const previewCard = byId('jjAuthorityPreviewCard');
    const lightbox = byId('jjAuthorityLightbox');
    const lightboxClose = byId('jjAuthorityLightboxClose');
    const occasionInput = byId('jjAuthorityOccasion');
    const moodInput = byId('jjAuthorityMood');
    const priorityInput = byId('jjAuthorityPriority');

    let currentAuthorityImageUrl = '';
    let currentAuthorityApiImageUrl = '';

    function hasPreview() {
      return !!(currentAuthorityApiImageUrl || currentAuthorityImageUrl);
    }

    function openLightbox() {
      if (!hasPreview() || !lightbox) return;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('jj-no-scroll');
      document.body.classList.add('jj-no-scroll');
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('jj-no-scroll');
      document.body.classList.remove('jj-no-scroll');
    }

    function resetRead() {
      currentAuthorityImageUrl = '';
      currentAuthorityApiImageUrl = '';
      setAuthorityPreview('', '');

      if (fileInput) fileInput.value = '';
      if (occasionInput) occasionInput.value = '';
      if (moodInput) moodInput.value = '';
      if (priorityInput) priorityInput.value = '';

      const scoreValueEl = byId('jjAuthorityScoreValue');
      const scoreStateEl = byId('jjAuthorityScoreState');
      const readStateEl = byId('jjAuthorityReadState');
      const readCopyEl = byId('jjAuthorityReadCopy');
      const readTimeEl = byId('jjAuthorityReadTime');
      const lookMessageEl = byId('jjAuthorityLookMessage');
      const nextMoveEl = byId('jjAuthorityNextMove');
      const lightboxImage = byId('jjAuthorityLightboxImage');

      if (scoreValueEl) scoreValueEl.textContent = '—';
      if (scoreStateEl) scoreStateEl.textContent = 'Awaiting Look';
      if (readStateEl) readStateEl.textContent = 'No Read Yet';
      if (readCopyEl) {
        readCopyEl.textContent = 'Upload a look and run the review to generate the current lead read, directional note, and next move.';
      }
      if (readTimeEl) readTimeEl.textContent = 'No review has been run.';
      if (lookMessageEl) lookMessageEl.textContent = 'This area updates after the review is run.';
      if (nextMoveEl) nextMoveEl.textContent = 'Use the upload and run controls below to activate the review.';
      if (lightboxImage) lightboxImage.removeAttribute('src');

      closeLightbox();
    }

    if (fileInput) {
      fileInput.addEventListener('change', async function (event) {
        const file = event.target.files && event.target.files[0];
        if (!file) return;

        const statusLine = byId('jjAuthorityStatusLine');
        if (statusLine) statusLine.textContent = 'Uploading look...';

        try {
          currentAuthorityApiImageUrl = await readFileAsDataUrl(file);
          if (currentAuthorityApiImageUrl) {
            setAuthorityPreview(currentAuthorityApiImageUrl, file.name || 'Uploaded look');
          }
          currentAuthorityImageUrl = '';
          if (statusLine) statusLine.textContent = 'Look ready for review.';
        } catch (error) {
          console.error('AUTHORITY UPLOAD ERROR:', error);
          if (currentAuthorityApiImageUrl) {
            if (statusLine) {
              statusLine.textContent = 'Look ready for review.';
            }
          } else {
            currentAuthorityImageUrl = '';
            if (statusLine) {
              statusLine.textContent = error && error.message
                ? error.message
                : 'Upload failed.';
            }
          }
        }
      });
    }

    if (runBtn) {
      runBtn.addEventListener('click', async function () {
        if (!hasPreview()) {
          const statusLine = byId('jjAuthorityStatusLine');
          if (statusLine) statusLine.textContent = 'Please upload a look first.';
          return;
        }

        try {
          if (runBtn) runBtn.disabled = true;
          const statusLine = byId('jjAuthorityStatusLine');
          if (statusLine) statusLine.textContent = 'Analyzing your look. Please wait.';

          const authorityImage = currentAuthorityApiImageUrl || currentAuthorityImageUrl;
          const authorityResponse = await runAuthorityRead(authorityImage);
          const result = authorityResponse && authorityResponse.result
            ? authorityResponse.result
            : authorityResponse;

          if (result && typeof result === 'object') {
            applyAuthorityReadResult(result);
          } else {
            setAuthorityReadError();
          }
        } catch (error) {
          console.error('AUTHORITY RUN ERROR:', error);
          setAuthorityReadError();
        } finally {
          if (runBtn) runBtn.disabled = false;
        }
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', resetRead);
    }

    if (expandBtn) {
      expandBtn.addEventListener('click', openLightbox);
    }

    if (previewCard) {
      previewCard.addEventListener('click', openLightbox);
      previewCard.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openLightbox();
        }
      });
    }

    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }

    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) {
          closeLightbox();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });
  }

  /* ===============================
     MIRROR
  ================================ */

  function initMirrorControls() {
    const root = byId('jj-dressing-room');
    const mirrorToggleBtn = byId('jj-droom-toggle-mirror');
    const buildLookBtn = byId('jj-droom-build-look');
    const resetLookBtn = byId('jj-droom-reset-look');
    if (!root) return;

    if (buildLookBtn) {
      buildLookBtn.textContent = 'Scan My Closet';
    }

    const lookNote = byId('jj-droom-look-note');
    if (lookNote) {
      lookNote.textContent = 'Tap a wardrobe piece, choose Build Look Around This Piece, and the room will assemble supporting pieces.';
    }

    function setMirrorExpanded(expanded) {
      root.classList.toggle('is-expanded', !!expanded);
      if (mirrorToggleBtn) {
        mirrorToggleBtn.textContent = expanded ? 'Hide Mirror' : 'Reveal Mirror';
        mirrorToggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    if (mirrorToggleBtn) {
      mirrorToggleBtn.addEventListener('click', function () {
        setMirrorExpanded(!root.classList.contains('is-expanded'));
      });
    }

    if (buildLookBtn) {
      buildLookBtn.addEventListener('click', function () {
        buildSignalLook();
      });
    }

    if (resetLookBtn) {
      resetLookBtn.addEventListener('click', function () {
        resetSignalLook();
      });
    }

    root.addEventListener('click', function (event) {
      const swapBtn = event.target.closest('[data-jj-swap-slot]');
      if (!swapBtn || !root.contains(swapBtn)) return;
      event.preventDefault();
      rerollSignalSlot(swapBtn.getAttribute('data-jj-swap-slot'));
    });

    jjUpdateBucketGuidance();
    initBucketDropzones();
    setMirrorExpanded(false);
  }

  function jjScrollSignalMirrorIntoView() {
    const root = byId('jj-dressing-room');
    if (!root) return;

    const mirror = root.querySelector('.jj-droom__mirrorFrame') || byId('jj-droom-mirror') || root;
    window.setTimeout(function () {
      mirror.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 120);
  }

  function jjMirrorSlotLabel(id) {
    const labels = {
      'jj-droom-slot-outerwear': 'Outerwear',
      'jj-droom-slot-top': 'Top',
      'jj-droom-slot-bottom': 'Bottom / Dress',
      'jj-droom-slot-shoe': 'Shoe',
      'jj-droom-slot-bag': 'Bag',
      'jj-droom-slot-accessory': 'Accessory'
    };
    return labels[id] || 'Piece';
  }

  function jjMirrorSlotSwapKey(id, piece) {
    if (id === 'jj-droom-slot-outerwear') return 'outerwear_id';
    if (id === 'jj-droom-slot-top') return 'top_id';
    if (id === 'jj-droom-slot-shoe') return 'shoe_id';
    if (id === 'jj-droom-slot-bag') return 'bag_id';
    if (id === 'jj-droom-slot-accessory') return 'accessory_id';
    if (id === 'jj-droom-slot-bottom') {
      const type = piece && piece.getAttribute('data-piece-type');
      return type === 'dress' ? 'dress_id' : 'bottom_id';
    }
    return '';
  }

  function jjSlotMarkup(id, piece) {
    const img = piece.querySelector('img');
    const fallback = piece.getAttribute('data-piece-note') || piece.getAttribute('data-piece-type') || 'Wardrobe piece';
    const pieceId = piece.getAttribute('data-piece-id') || '';
    const swapKey = jjMirrorSlotSwapKey(id, piece);
    const label = jjMirrorSlotLabel(id);
    const isAnchor = pieceId && String(pieceId) === String(jjSignalAnchorId || '');
    const media = img
      ? `<img src="${img.src}" alt="${img.alt || 'Selected wardrobe piece'}" class="jj-droom__slotImg">`
      : `<span>${jjEscapeHtml(fallback)}</span>`;
    const swap = swapKey && !isAnchor
      ? `<button type="button" class="jj-droom__slotSwap" data-jj-swap-slot="${jjEscapeHtml(swapKey)}">Swap ${jjEscapeHtml(label)}</button>`
      : '';

    return `<div class="jj-droom__slotSelection">${media}${swap}</div>`;
  }

  function setSlot(id, piece) {
    const slot = byId(id);
    if (!slot) return;

    const pieces = Array.isArray(piece) ? piece.filter(Boolean) : (piece ? [piece] : []);

    if (!pieces.length) {
      slot.textContent = 'Awaiting piece';
      return;
    }

    if (pieces.length === 1) {
      slot.innerHTML = jjSlotMarkup(id, pieces[0]);
      return;
    }

    slot.innerHTML = '<div style="display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:6px;align-items:start;">' + pieces.map(function (slotPiece, index) {
      const img = slotPiece.querySelector('img');
      const label = index === 0 ? 'Anchor Layer' : 'Under Layer';
      const fallback = slotPiece.getAttribute('data-piece-note') || slotPiece.getAttribute('data-piece-type') || 'Wardrobe piece';
      return '<div style="min-width:0;">'
        + (img
          ? `<img src="${img.src}" alt="${img.alt || 'Selected wardrobe piece'}" class="jj-droom__slotImg" style="max-width:100%;margin-top:4px;">`
          : `<span>${jjEscapeHtml(fallback)}</span>`)
        + `<small style="display:block;margin-top:4px;font-size:9px;letter-spacing:.12em;text-transform:uppercase;line-height:1.2;">${label}</small>`
        + '</div>';
    }).join('') + '</div>';
  }

  function ensureOuterwearMirrorSlot() {
    const existing = byId('jj-droom-slot-outerwear');
    if (existing) return existing;

    const topSlot = byId('jj-droom-slot-top');
    const topWrapper = topSlot ? topSlot.closest('.jj-droom__slot') : null;
    if (!topSlot || !topWrapper || !topWrapper.parentNode) return null;

    const outerwearWrapper = topWrapper.cloneNode(false);
    const label = document.createElement('span');
    label.textContent = 'Outerwear / Reveal Layer';

    const fill = document.createElement('div');
    fill.className = 'jj-droom__slotFill';
    fill.id = 'jj-droom-slot-outerwear';
    fill.textContent = 'Awaiting piece';

    outerwearWrapper.appendChild(label);
    outerwearWrapper.appendChild(fill);
    topWrapper.parentNode.insertBefore(outerwearWrapper, topWrapper);
    return fill;
  }

  function routePieceToMirror(piece) {
    const root = byId('jj-dressing-room');
    if (!root || !piece) return;

    const anchorId = piece.getAttribute('data-piece-id');
    jjSignalAnchorId = anchorId || jjSignalAnchorId;
    if (anchorId) root.setAttribute('data-signal-anchor', anchorId);

    root.querySelectorAll('.jj-droom__piece.is-styling-anchor').forEach(function (activePiece) {
      activePiece.classList.remove('is-styling-anchor');
    });
    piece.classList.add('is-styling-anchor');

    root.classList.add('is-expanded');

    const mirrorToggleBtn = byId('jj-droom-toggle-mirror');
    if (mirrorToggleBtn) {
      mirrorToggleBtn.textContent = 'Hide Mirror';
      mirrorToggleBtn.setAttribute('aria-expanded', 'true');
    }

    const type = piece.getAttribute('data-piece-type');
    ensureOuterwearMirrorSlot();
    if (type === 'outerwear') setSlot('jj-droom-slot-outerwear', piece);
    else if (type === 'top' || type === 'garment') setSlot('jj-droom-slot-top', piece);
    else if (type === 'bottom' || type === 'dress') setSlot('jj-droom-slot-bottom', piece);
    else if (type === 'shoe') setSlot('jj-droom-slot-shoe', piece);
    else if (type === 'bag') setSlot('jj-droom-slot-bag', piece);
    else if (type === 'accessory') setSlot('jj-droom-slot-accessory', piece);

    const lookNote = byId('jj-droom-look-note');
    if (lookNote) {
      lookNote.textContent = 'Anchor selected. The room is ready to build supporting pieces around this item.';
    }

    jjScrollSignalMirrorIntoView();
  }

  function resetSignalLook() {
    const root = byId('jj-dressing-room');
    if (!root) return;

    resetScanRanks(root);
    ensureOuterwearMirrorSlot();
    setSlot('jj-droom-slot-outerwear', null);
    setSlot('jj-droom-slot-top', null);
    setSlot('jj-droom-slot-bottom', null);
    setSlot('jj-droom-slot-shoe', null);
    setSlot('jj-droom-slot-bag', null);
    setSlot('jj-droom-slot-accessory', null);

    const lookNote = byId('jj-droom-look-note');
    if (lookNote) {
      lookNote.textContent = 'Tap a wardrobe piece to choose its move, or let the room scan the closet and build a first-pass combination.';
    }

    const mirrorToggleBtn = byId('jj-droom-toggle-mirror');
    if (mirrorToggleBtn) {
      mirrorToggleBtn.textContent = 'Reveal Mirror';
      mirrorToggleBtn.setAttribute('aria-expanded', 'false');
    }

    const buildLookBtn = byId('jj-droom-build-look');
    if (buildLookBtn) {
      buildLookBtn.disabled = false;
      buildLookBtn.textContent = 'Scan My Closet';
    }

    jjSignalAnchorId = null;
    jjCurrentSignalLook = null;
    root.removeAttribute('data-signal-anchor');
    root.classList.remove('is-expanded', 'is-scanning');
  }

  async function buildSignalLook(options) {
    const root = byId('jj-dressing-room');
    if (!root) return;

    const pieces = jjClientItems || [];
    if (!pieces.length) {
      jjSetClosetStatus('Upload pieces before building a look.');
      return;
    }

    const scanOptions = options || {};
    const anchorId = scanOptions.anchorId || jjSignalAnchorId || root.getAttribute('data-signal-anchor') || null;
    const anchorPiece = anchorId ? findPieceById(anchorId) : null;
    const anchorItem = anchorId ? pieces.find(function (item) {
      return String(item.id) === String(anchorId);
    }) : null;

    root.classList.add('is-expanded');
    root.classList.add('is-scanning');
    jjScrollSignalMirrorIntoView();
    jjSetSignalScanState('scanning');
    resetScanRanks(root);

    if (anchorPiece) {
      root.querySelectorAll('.jj-droom__piece.is-styling-anchor').forEach(function (activePiece) {
        activePiece.classList.remove('is-styling-anchor');
      });
      anchorPiece.classList.add('is-styling-anchor');
      jjSignalAnchorId = anchorId;
      root.setAttribute('data-signal-anchor', anchorId);
    }

    const mirrorToggleBtn = byId('jj-droom-toggle-mirror');
    if (mirrorToggleBtn) {
      mirrorToggleBtn.textContent = 'Hide Mirror';
      mirrorToggleBtn.setAttribute('aria-expanded', 'true');
    }

    const lookNote = byId('jj-droom-look-note');
    if (lookNote) {
      lookNote.textContent = anchorItem
        ? 'Mirror Scan active. Building supporting pieces around ' + jjReadablePieceName(anchorItem) + '...'
        : 'Mirror Scan active. Reading proportion, category balance, and strongest signal pieces...';
    }

    const buildLookBtn = byId('jj-droom-build-look');
    if (buildLookBtn) {
      buildLookBtn.disabled = true;
      buildLookBtn.textContent = 'Building first pass...';
    }

    const instantLook = buildVariedSignalLook(pieces, anchorId, null);
    applyScanRanks(root, instantLook, anchorId);
    setLookSlots(instantLook);
    if (lookNote) {
      lookNote.textContent = 'First pass assembled. Refining the read now...';
    }
    if (buildLookBtn) {
      buildLookBtn.textContent = 'Refining...';
    }

    let buildLookTimeout = null;
    try {
      const controller = window.AbortController ? new AbortController() : null;
      buildLookTimeout = controller ? window.setTimeout(function () {
        controller.abort();
      }, 3600) : null;
      const response = await fetch('https://jj-intelligence-engine.vercel.app/api/build-look', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: controller ? controller.signal : undefined,
        body: JSON.stringify({
          pieces: pieces.map(function (item) {
            return {
              id: item.id,
              piece_type: item.piece_type,
              description: item.ai_description || item.note || '',
              color: item.ai_color || '',
              material: item.ai_material || '',
              silhouette: item.ai_silhouette || ''
            };
          }),
          anchor_id: anchorId,
          avoid_ids: jjSignalRecentIds(),
          recent_slot_ids: jjRecentSignalSlots,
          anchor_piece: anchorItem ? {
            id: anchorItem.id,
            piece_type: anchorItem.piece_type,
            description: anchorItem.ai_description || anchorItem.note || '',
            color: anchorItem.ai_color || '',
            material: anchorItem.ai_material || '',
            silhouette: anchorItem.ai_silhouette || ''
          } : null
        })
      });

      if (!response.ok) throw new Error('Build look request failed.');

      const apiLook = await response.json();
      const look = buildVariedSignalLook(pieces, anchorId, jjLookHasPieces(apiLook) ? apiLook : null);
      applyScanRanks(root, look, anchorId);
      setLookSlots(look);

      if (lookNote) {
        lookNote.textContent = jjBuildLookNarrative(look, anchorItem);
      }
    } catch (error) {
      console.error('BUILD LOOK ERROR:', error);
      if (lookNote) {
        lookNote.textContent = jjBuildLookNarrative(instantLook, anchorItem);
      }
    } finally {
      if (buildLookTimeout) window.clearTimeout(buildLookTimeout);
      root.classList.remove('is-scanning');
      jjSetSignalScanState('complete');
      if (buildLookBtn) {
        buildLookBtn.disabled = false;
        buildLookBtn.textContent = 'Scan Again';
      }
    }
  }

  function waitForScanBeat(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function jjSafePieceSelectorValue(id) {
    if (id === null || id === undefined || id === '') return '';
    const value = String(id);
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function findPieceById(id) {
    const selectorValue = jjSafePieceSelectorValue(id);
    if (!selectorValue) return null;
    return document.querySelector('[data-piece-id="' + selectorValue + '"]');
  }

  function jjLookHasPieces(look) {
    if (!look || typeof look !== 'object') return false;
    return !!(look.top_id || look.outerwear_id || look.bottom_id || look.dress_id || look.shoe_id || look.bag_id || look.accessory_id);
  }

  function setLookSlots(look) {
    const safeLook = look || {};
    jjCurrentSignalLook = Object.assign({}, safeLook);
    ensureOuterwearMirrorSlot();
    const topPiece = findPieceById(safeLook.top_id);
    const outerwearPiece = findPieceById(safeLook.outerwear_id);
    setSlot('jj-droom-slot-outerwear', outerwearPiece);
    setSlot('jj-droom-slot-top', topPiece);
    setSlot('jj-droom-slot-bottom', findPieceById(safeLook.bottom_id) || findPieceById(safeLook.dress_id));
    setSlot('jj-droom-slot-shoe', findPieceById(safeLook.shoe_id));
    setSlot('jj-droom-slot-bag', findPieceById(safeLook.bag_id));
    setSlot('jj-droom-slot-accessory', findPieceById(safeLook.accessory_id));
  }

  function jjSlotTypesForKey(slotKey, currentLook) {
    if (slotKey === 'top_id') return ['top', 'garment'];
    if (slotKey === 'outerwear_id') return ['outerwear'];
    if (slotKey === 'shoe_id') return ['shoe'];
    if (slotKey === 'bag_id') return ['bag'];
    if (slotKey === 'accessory_id') return ['accessory'];
    if (slotKey === 'dress_id') return ['dress'];
    if (slotKey === 'bottom_id' && currentLook && currentLook.dress_id && !currentLook.bottom_id) return ['dress'];
    if (slotKey === 'bottom_id') return ['bottom'];
    return [];
  }

  function jjCurrentLookIdsExcept(slotKey) {
    const look = jjCurrentSignalLook || {};
    return ['top_id', 'outerwear_id', 'bottom_id', 'dress_id', 'shoe_id', 'bag_id', 'accessory_id']
      .filter(function (key) {
        return key !== slotKey;
      })
      .map(function (key) {
        return look[key];
      })
      .filter(Boolean);
  }

  function rerollSignalSlot(slotKey) {
    const root = byId('jj-dressing-room');
    const lookNote = byId('jj-droom-look-note');
    const pieces = jjClientItems || [];
    const currentLook = Object.assign({}, jjCurrentSignalLook || {});
    if (!root || !slotKey || !pieces.length || !jjLookHasPieces(currentLook)) return;

    const effectiveSlotKey = slotKey === 'bottom_id' && currentLook.dress_id && !currentLook.bottom_id ? 'dress_id' : slotKey;
    const currentId = currentLook[effectiveSlotKey];
    const usedIds = new Set(jjCurrentLookIdsExcept(effectiveSlotKey).map(String));
    if (jjSignalAnchorId) usedIds.add(String(jjSignalAnchorId));
    if (currentId) usedIds.add(String(currentId));

    const replacementId = jjChooseSignalPiece(pieces, {
      slotKey: effectiveSlotKey,
      types: jjSlotTypesForKey(effectiveSlotKey, currentLook),
      anchorId: jjSignalAnchorId,
      anchorItem: jjSignalAnchorId ? pieces.find(function (item) {
        return String(item.id) === String(jjSignalAnchorId);
      }) : null,
      preferredId: null,
      usedIds: usedIds
    });

    if (!replacementId) {
      if (lookNote) lookNote.textContent = 'No alternate ' + jjSlotNameForNarrative(effectiveSlotKey) + ' is available yet. Upload another option to unlock a swap.';
      return;
    }

    currentLook[effectiveSlotKey] = replacementId;
    if (effectiveSlotKey === 'dress_id') currentLook.bottom_id = null;
    if (effectiveSlotKey === 'bottom_id') currentLook.dress_id = null;
    currentLook.title = currentLook.title || (jjSignalAnchorId ? 'Anchor Look' : 'Signal Mirror');
    currentLook.styling_note = 'Kept the rest of the look and reran the ' + jjSlotNameForNarrative(effectiveSlotKey) + ' pairing.';

    jjSignalBuildCount += 1;
    jjRememberSignalLook(currentLook);
    applyScanRanks(root, currentLook, jjSignalAnchorId);
    setLookSlots(currentLook);
    if (lookNote) {
      lookNote.textContent = jjBuildLookNarrative(currentLook, jjSignalAnchorId ? pieces.find(function (item) {
        return String(item.id) === String(jjSignalAnchorId);
      }) : null);
    }
  }

  function jjSlotNameForNarrative(slotKey) {
    const names = {
      top_id: 'top',
      outerwear_id: 'outerwear',
      bottom_id: 'bottom',
      dress_id: 'dress',
      shoe_id: 'shoe',
      bag_id: 'handbag',
      accessory_id: 'accessory'
    };
    return names[slotKey] || 'piece';
  }

  function jjBuildLookNarrative(look, anchorItem) {
  const safeLook = look || {};
  const selectedItems = jjLookItems(safeLook);
  const selectedNames = selectedItems.map(jjReadablePieceName).filter(Boolean);
	  const selectedTypes = selectedItems.map(function (item) {
	    return jjEffectiveSignalType(item);
	  });
  const hasAnchor = !!anchorItem;
  const anchorName = hasAnchor ? jjReadablePieceName(anchorItem) : '';
  const title = safeLook.title || (hasAnchor ? 'Anchor Look' : 'Lead Look');
  const stylingNote = safeLook.styling_note || '';

  const intro = hasAnchor
    ? title + ': ' + (stylingNote || 'Supporting pieces were assembled around the selected wardrobe anchor.') + ' Built around ' + anchorName + '.'
    : title + ': ' + (stylingNote || 'Built from the strongest available wardrobe signal.');

  const combination = selectedNames.length
    ? 'The room paired ' + jjJoinReadableList(selectedNames.slice(0, 5)) + ' so the look has a clear anchor, supporting structure, and finish.'
    : 'The room needs more uploaded pieces before it can describe the full combination.';

  return intro + ' ' + combination + ' ' + jjLookStrengthSentence(selectedTypes) + ' ' + jjLookReadSentence(selectedItems, selectedTypes, anchorItem) + ' ' + jjLookImprovementSentence(selectedTypes) + ' Tap any piece to approve Keep, Tailor, Release, or Consign.';
}

function jjLookItems(look) {
  const ids = [
    look.top_id,
    look.outerwear_id,
    look.bottom_id,
    look.dress_id,
    look.shoe_id,
    look.bag_id,
    look.accessory_id
  ].filter(Boolean).filter(function (id, index, idsList) {
    return idsList.findIndex(function (candidate) {
      return String(candidate) === String(id);
    }) === index;
  });

  return ids.map(function (id) {
    return (jjClientItems || []).find(function (item) {
      return String(item.id) === String(id);
    });
  }).filter(Boolean);
}

function jjLookStrengthSentence(types) {
  const hasDress = types.includes('dress');
  const hasTop = types.includes('top') || types.includes('garment') || types.includes('outerwear');
  const hasBottom = types.includes('bottom');
  const hasShoe = types.includes('shoe');
  const hasBag = types.includes('bag');
  const hasAccessory = types.includes('accessory');

  if ((hasDress || (hasTop && hasBottom)) && hasShoe && (hasBag || hasAccessory)) {
    return 'What makes it strong: it has a complete line, a grounded finish, and enough accessory direction to feel intentional instead of assembled.';
  }

  if (hasDress && hasShoe) {
    return 'What makes it strong: the dress and shoe create an immediate silhouette, so the look already has a readable point of view.';
  }

  if (hasTop && hasBottom) {
    return 'What makes it strong: the top and bottom give the look structure; the foundation is clear enough to style upward.';
  }

  return 'What makes it strong: the selected anchor gives the room a clear starting point for proportion, tone, and wardrobe direction.';
}

function jjLookReadSentence(items, types, anchorItem) {
  const hasOuterwear = types.includes('outerwear');
  const hasDress = types.includes('dress');
  const hasTop = types.includes('top') || types.includes('garment');
  const hasBottom = types.includes('bottom');
  const hasShoe = types.includes('shoe');

  if (hasOuterwear && hasDress && hasShoe) {
    return 'What the look is saying: polished, event-ready, and intentionally styled, with the outer layer making the dress feel more directed.';
  }

  if (hasTop && hasBottom && hasShoe) {
    return 'What the look is saying: clean, usable, and pulled together without feeling overworked. This reads like a real outfit, not just separate pieces.';
  }

  if (hasDress) {
    return 'What the look is saying: the dress is carrying the silhouette, so the supporting pieces need to sharpen the finish rather than compete with it.';
  }

  if (anchorItem) {
    return 'What the look is saying: the anchor is setting the tone, and the room is looking for pieces that make it feel intentional instead of incidental.';
  }

  return 'What the look is saying: the wardrobe has enough signal to begin a look, but the final read depends on one stronger finishing piece.';
}

function jjLookImprovementSentence(types) {
  const hasDress = types.includes('dress');
  const hasTop = types.includes('top') || types.includes('garment') || types.includes('outerwear');
  const hasBottom = types.includes('bottom');
  const hasShoe = types.includes('shoe');
  const hasBag = types.includes('bag');
  const hasAccessory = types.includes('accessory');

  if (!hasShoe) return 'Best closet addition: a sharper shoe would complete the read and make the outfit feel finished.';
  if (!hasBag) return 'Best closet addition: a stronger bag would give the look polish and make it feel more expensive.';
  if (!hasAccessory) return 'Best closet addition: one decisive accessory would add authority without making the outfit noisy.';
  if (!hasDress && !(hasTop && hasBottom)) return 'Best closet addition: a clean base layer would improve the silhouette and make the anchor easier to wear.';

  return 'Best improvement: refine with tailoring or one quieter finishing piece rather than adding more visual noise.';
}

function jjJoinReadableList(items) {
  if (!items.length) return '';
  if (items.length === 1) return items[0];
  if (items.length === 2) return items[0] + ' and ' + items[1];
  return items.slice(0, -1).join(', ') + ', and ' + items[items.length - 1];
}

  function resetScanRanks(root) {
    if (!root) return;
    root.querySelectorAll('.jj-droom__piece').forEach(function (piece) {
      piece.classList.remove('is-scan-lead', 'is-scan-support', 'is-scan-tailor', 'is-scan-release');
      piece.removeAttribute('data-scan-rank');
    });
  }

  function applyScanRanks(root, look, anchorId) {
    if (!root || !look) return;
    resetScanRanks(root);

    const leadIds = [
      anchorId,
      look.top_id,
      look.outerwear_id,
      look.bottom_id,
      look.dress_id,
      look.shoe_id,
      look.bag_id,
      look.accessory_id
    ].filter(Boolean).filter(function (id, index, ids) {
      return ids.findIndex(function (candidate) {
        return String(candidate) === String(id);
      }) === index;
    });

    leadIds.forEach(function (id, index) {
      const piece = findPieceById(id);
      if (!piece) return;
      piece.classList.add(index === 0 ? 'is-scan-lead' : 'is-scan-support');
      piece.setAttribute('data-scan-rank', index === 0 ? 'Lead Piece' : 'Supporting Piece');
    });

    root.querySelectorAll('.jj-droom__piece:not(.is-scan-lead):not(.is-scan-support)').forEach(function (piece) {
      const type = piece.getAttribute('data-piece-type') || '';
      const label = type === 'shoe' || type === 'bag' || type === 'accessory' ? 'Support Reserve' : 'Review Piece';
      piece.classList.add(label === 'Support Reserve' ? 'is-scan-support' : 'is-scan-tailor');
      piece.setAttribute('data-scan-rank', label);
    });
  }

  function jjApplyAnchorToLook(look, anchorId) {
    const safeLook = look || {};
    const anchorItem = anchorId ? (jjClientItems || []).find(function (item) {
      return String(item.id) === String(anchorId);
    }) : null;
    if (!anchorItem) return safeLook;

    const anchorType = jjEffectiveSignalType(anchorItem);
    ['top_id', 'outerwear_id', 'bottom_id', 'dress_id', 'shoe_id', 'bag_id', 'accessory_id'].forEach(function (key) {
      if (safeLook[key] && String(safeLook[key]) === String(anchorId)) {
        safeLook[key] = null;
      }
    });

    if (anchorType === 'outerwear') safeLook.outerwear_id = anchorId;
    else if (anchorType === 'top' || anchorType === 'garment') safeLook.top_id = anchorId;
    else if (anchorType === 'bottom') safeLook.bottom_id = anchorId;
    else if (anchorType === 'dress') safeLook.dress_id = anchorId;
    else if (anchorType === 'shoe') safeLook.shoe_id = anchorId;
    else if (anchorType === 'bag') safeLook.bag_id = anchorId;
    else if (anchorType === 'accessory') safeLook.accessory_id = anchorId;

    if (anchorType === 'dress') {
      safeLook.bottom_id = null;
    }

    if (anchorType === 'outerwear') {
      ['top_id', 'bottom_id', 'dress_id'].forEach(function (key) {
        const supportItem = safeLook[key] ? (jjClientItems || []).find(function (item) {
          return String(item.id) === String(safeLook[key]);
        }) : null;
        if (supportItem && jjEffectiveSignalType(supportItem) === 'outerwear') {
          safeLook[key] = null;
        }
      });
    }

    safeLook.title = 'Anchor Look';
    safeLook.styling_note = 'Supporting pieces were assembled around the selected wardrobe anchor.';
    return safeLook;
  }

  function buildVariedSignalLook(pieces, anchorId, baseLook) {
    jjSignalBuildCount += 1;

    const anchorItem = anchorId ? pieces.find(function (item) {
      return String(item.id) === String(anchorId);
    }) : null;
    const anchorType = anchorItem ? jjEffectiveSignalType(anchorItem) : '';
    const useDressBase = anchorType === 'dress' || (!anchorType && jjSignalBuildCount % 3 === 0);
    const look = Object.assign({
      title: anchorItem ? 'Anchor Look' : 'Signal Mirror',
      styling_note: anchorItem
        ? 'Supporting pieces were assembled around the selected wardrobe anchor.'
        : 'A first-pass look was assembled from your available wardrobe categories.'
    }, baseLook || {});
    const preferredLook = Object.assign({}, look);
    const usedIds = new Set();

    if (anchorId) usedIds.add(String(anchorId));

    function assign(slotKey, types, extraOptions) {
      const chosenId = jjChooseSignalPiece(pieces, {
        slotKey: slotKey,
        types: types,
        anchorId: anchorId,
        anchorItem: anchorItem,
        preferredId: preferredLook[slotKey],
        usedIds: usedIds,
        disallowTypes: extraOptions && extraOptions.disallowTypes
      });
      look[slotKey] = chosenId;
      if (chosenId) usedIds.add(String(chosenId));
    }

    look.top_id = null;
    look.outerwear_id = null;
    look.bottom_id = null;
    look.dress_id = null;
    look.shoe_id = null;
    look.bag_id = null;
    look.accessory_id = null;

    if (useDressBase) {
      assign('dress_id', ['dress']);
      if (anchorType !== 'outerwear') assign('outerwear_id', ['outerwear']);
    } else {
      assign('top_id', ['top', 'garment'], { disallowTypes: ['outerwear'] });
      assign('bottom_id', ['bottom'], { disallowTypes: ['outerwear'] });
      if (anchorType !== 'outerwear') assign('outerwear_id', ['outerwear']);
    }

    assign('shoe_id', ['shoe']);
    assign('bag_id', ['bag']);
    assign('accessory_id', ['accessory']);

    const anchoredLook = jjApplyAnchorToLook(look, anchorId);
    jjRememberSignalLook(anchoredLook);
    return anchoredLook;
  }

  function jjChooseSignalPiece(pieces, options) {
    const slotKey = options.slotKey;
    const anchorId = options.anchorId;
    const preferredId = options.preferredId;
    const usedIds = options.usedIds || new Set();
    const recentIds = jjRecentSignalSlots[slotKey] || [];
    const candidates = pieces.filter(function (item) {
      const itemId = String(item.id);
      const itemType = jjEffectiveSignalType(item);
      return itemId !== String(anchorId || '')
        && !usedIds.has(itemId)
        && options.types.includes(itemType)
        && !(options.disallowTypes || []).includes(itemType);
    });

    if (!candidates.length) return null;
    options.hasAlternates = candidates.length > 1;

    candidates.sort(function (a, b) {
      return jjSignalPieceScore(b, options, recentIds) - jjSignalPieceScore(a, options, recentIds);
    });

    return candidates[0].id;
  }

  function jjSignalPieceScore(item, options, recentIds) {
    const itemId = String(item.id);
    const preferredId = options.preferredId ? String(options.preferredId) : '';
    let score = 0;

    if (preferredId && itemId === preferredId) score += 12;
    if (String(item.status || '').toLowerCase() === 'keep') score += 8;
    if (String(item.status || '').toLowerCase() === 'active') score += 5;
    if (item.ai_description || item.note) score += 3;
    if (item.ai_color) score += 2;
    if (item.ai_material || item.ai_silhouette) score += 1;
    if (item.ai_confidence) score += Math.min(Number(item.ai_confidence) || 0, 1) * 3;

    const recentIndex = recentIds.findIndex(function (recentId) {
      return String(recentId) === itemId;
    });
    if (options.hasAlternates && recentIndex !== -1) {
      score -= 35 - recentIndex * 4;
    }

    score += jjSignalHash([
      options.anchorId || 'no-anchor',
      itemId,
      options.slotKey,
      jjSignalBuildCount
    ].join('|')) % 17;

    return score;
  }

  function jjRememberSignalLook(look) {
    ['top_id', 'outerwear_id', 'bottom_id', 'dress_id', 'shoe_id', 'bag_id', 'accessory_id'].forEach(function (slotKey) {
      const id = look && look[slotKey];
      if (!id) return;
      const recent = jjRecentSignalSlots[slotKey] || [];
      jjRecentSignalSlots[slotKey] = [id].concat(recent.filter(function (recentId) {
        return String(recentId) !== String(id);
      })).slice(0, 5);
    });
  }

  function jjSignalRecentIds() {
    const ids = [];
    Object.keys(jjRecentSignalSlots).forEach(function (slotKey) {
      (jjRecentSignalSlots[slotKey] || []).forEach(function (id) {
        if (id && !ids.includes(String(id))) ids.push(String(id));
      });
    });
    return ids.slice(0, 20);
  }

  function jjSignalHash(value) {
    return String(value || '').split('').reduce(function (hash, char) {
      return ((hash << 5) - hash + char.charCodeAt(0)) >>> 0;
    }, 0);
  }

  function initBucketDropzones() {
    [
      byId('jj-droom-bucket-keep'),
      byId('jj-droom-bucket-tailor'),
      byId('jj-droom-bucket-release'),
      byId('jj-droom-bucket-consign')
    ].filter(Boolean).forEach(function (bucket) {
      bucket.addEventListener('dragover', function (event) {
        event.preventDefault();
        bucket.classList.add('is-over');
      });

      bucket.addEventListener('dragleave', function () {
        bucket.classList.remove('is-over');
      });

      bucket.addEventListener('drop', async function (event) {
        event.preventDefault();
        bucket.classList.remove('is-over');

        const pieceId = event.dataTransfer.getData('text/plain');
        if (!pieceId) return;

        const piece = findPieceById(pieceId);
        if (!piece) return;

        const status = bucket.id.replace('jj-droom-bucket-', '');
        const previousBucket = piece.closest('.jj-droom__bucketDrop');
        bucket.appendChild(piece);
        if (previousBucket && previousBucket !== bucket) jjSyncBucketEmpty(previousBucket);
        jjSyncBucketEmpty(bucket);

        await updateItemStatus(pieceId, status);
        updateDressingRoomInsights();
      });
    });
  }

  function jjUpdateBucketGuidance() {
    const guidance = {
      'jj-droom-bucket-keep': 'Tap a piece and choose Keep',
      'jj-droom-bucket-tailor': 'Tap a piece and choose Tailor',
      'jj-droom-bucket-release': 'Tap a piece and choose Release',
      'jj-droom-bucket-consign': 'Tap a piece and choose Consign'
    };

    Object.keys(guidance).forEach(function (id) {
      const bucket = byId(id);
      if (!bucket) return;
      const empty = bucket.querySelector('.jj-droom__bucketEmpty');
      if (empty) empty.textContent = guidance[id];
    });
  }

  function updateDressingRoomInsights() {
    const statTotal = byId('jj-droom-stat-total');
    const strongestEl = byId('jj-droom-strongest');
    const underbuiltEl = byId('jj-droom-underbuilt');
    const fastLiftEl = byId('jj-droom-fastlift');
    const keepCountEl = byId('jj-droom-keep-count');
    const tailorCountEl = byId('jj-droom-tailor-count');
    const releaseCountEl = byId('jj-droom-release-count');
    const consignCountEl = byId('jj-droom-consign-count');
    const items = jjClientItems || [];
    jjUpdateSignalRoom(items);

    if (statTotal) statTotal.textContent = String(items.length);
    if (keepCountEl) keepCountEl.textContent = String(items.filter(function (item) { return item.status === 'active' || item.status === 'keep'; }).length);
    if (tailorCountEl) tailorCountEl.textContent = String(items.filter(function (item) { return item.status === 'tailor'; }).length);
    if (releaseCountEl) releaseCountEl.textContent = String(items.filter(function (item) { return item.status === 'release'; }).length);
    if (consignCountEl) consignCountEl.textContent = String(items.filter(function (item) { return item.status === 'consign'; }).length);

    if (!items.length) {
      if (strongestEl) strongestEl.textContent = 'Awaiting uploads';
      if (underbuiltEl) underbuiltEl.textContent = 'Awaiting uploads';
      if (fastLiftEl) fastLiftEl.textContent = 'Awaiting uploads';
      return;
    }

    const counts = items.reduce(function (acc, item) {
      const type = jjEffectiveSignalType(item);
      acc[type] = (acc[type] || 0) + 1;
      return acc;
    }, {});

    const sorted = Object.keys(counts).map(function (key) {
      return { type: key, count: counts[key] };
    }).sort(function (a, b) {
      return b.count - a.count;
    });

    const allTypes = ['top', 'bottom', 'dress', 'outerwear', 'shoe', 'bag', 'accessory', 'garment'];
    const weakest = allTypes.map(function (type) {
      return { type: type, count: counts[type] || 0 };
    }).sort(function (a, b) {
      return a.count - b.count;
    })[0];

    if (strongestEl) strongestEl.textContent = sorted[0] ? sorted[0].type : 'Awaiting uploads';
    if (underbuiltEl) underbuiltEl.textContent = weakest ? weakest.type : 'Awaiting uploads';
    if (fastLiftEl) fastLiftEl.textContent = 'Reveal the mirror and build a complete look.';
  }

  window.JJCloset = {
    load: loadClosetItems,
    upload: uploadClosetItem,
    delete: deleteClosetItem,
    updateStatus: updateItemStatus,
    buildSignalLook: buildSignalLook
  };

  /* ===============================
     PROFILE
  ================================ */

  async function loadClientProfile() {
    const supabase = await jjInitSupabase();
    const user = await jjGetOptionalAuthUser();
    const ownerId = jjClientOwnerId(user);
    const email = jjClientEmail(user);

    let query = supabase
      .from(JJ_PROFILE_TABLE)
      .select('*');

    if (user && user.id) {
      query = query.eq('user_id', user.id);
    } else if (client.shopifyCustomerId) {
      query = query.eq('shopify_customer_id', String(client.shopifyCustomerId));
    } else if (email) {
      query = query.eq('client_email', email);
    } else {
      query = query.eq('user_id', ownerId);
    }

    const result = await query.maybeSingle();

    if (result.error) {
      console.error('LOAD PROFILE ERROR:', result.error);
      return null;
    }

    return result.data;
  }

  function getProfilePayload() {
    return {
      overview: {
        name: byId('jj-profile-name') ? byId('jj-profile-name').value : '',
        city: byId('jj-profile-city') ? byId('jj-profile-city').value : '',
        phone: byId('jj-profile-phone') ? byId('jj-profile-phone').value : '',
        shipping_notes: byId('jj-profile-ship') ? byId('jj-profile-ship').value : '',
        private_notes: byId('jj-profile-notes') ? byId('jj-profile-notes').value : ''
      },
      fit_sizes: {
        top_size: byId('jj-profile-size-top') ? byId('jj-profile-size-top').value : '',
        bottom_size: byId('jj-profile-size-bottom') ? byId('jj-profile-size-bottom').value : '',
        dress_size: byId('jj-profile-size-dress') ? byId('jj-profile-size-dress').value : '',
        shoe_size: byId('jj-profile-size-shoe') ? byId('jj-profile-size-shoe').value : '',
        preferred_fit: byId('jj-profile-fit') ? byId('jj-profile-fit').value : '',
        tailoring_notes: byId('jj-profile-tailoring') ? byId('jj-profile-tailoring').value : '',
        measurements: byId('jj-profile-measurements') ? byId('jj-profile-measurements').value : ''
      },
      preferences: {
        brand_preferences: byId('jj-profile-brands') ? byId('jj-profile-brands').value : '',
        color_preferences: byId('jj-profile-colors') ? byId('jj-profile-colors').value : '',
        avoid: byId('jj-profile-avoid') ? byId('jj-profile-avoid').value : '',
        category_priorities: byId('jj-profile-priority') ? byId('jj-profile-priority').value : '',
        lifestyle_needs: byId('jj-profile-lifestyle') ? byId('jj-profile-lifestyle').value : '',
        spending_posture: byId('jj-profile-spend') ? byId('jj-profile-spend').value : ''
      },
      uploads: {
        portrait_url: window.JJ_PROFILE_PORTRAIT_URL || ''
      }
    };
  }

  async function saveClientProfile() {
    const supabase = await jjInitSupabase();
    const user = await jjGetOptionalAuthUser();
    const ownerId = jjClientOwnerId(user);
    const email = jjClientEmail(user);
    const payload = getProfilePayload();
    const baseRecord = {
      user_id: user && user.id ? user.id : ownerId,
      client_email: email,
      shopify_customer_id: client.shopifyCustomerId ? String(client.shopifyCustomerId) : null,
      ...payload,
      updated_at: new Date().toISOString()
    };

    let existingQuery = supabase.from(JJ_PROFILE_TABLE).select('id');
    if (user && user.id) {
      existingQuery = existingQuery.eq('user_id', user.id);
    } else if (client.shopifyCustomerId) {
      existingQuery = existingQuery.eq('shopify_customer_id', String(client.shopifyCustomerId));
    } else if (email) {
      existingQuery = existingQuery.eq('client_email', email);
    } else {
      existingQuery = existingQuery.eq('user_id', ownerId);
    }

    const existing = await existingQuery.maybeSingle();

    if (existing.error) {
      console.error('FIND PROFILE ERROR:', existing.error);
      alert('Unable to save profile.');
      return;
    }

    const result = existing.data && existing.data.id
      ? await supabase
        .from(JJ_PROFILE_TABLE)
        .update(baseRecord)
        .eq('id', existing.data.id)
      : await supabase
        .from(JJ_PROFILE_TABLE)
        .insert({
          ...baseRecord,
          created_at: new Date().toISOString()
        });

    if (result.error) {
      console.error('SAVE PROFILE ERROR:', result.error);
      alert('Unable to save profile.');
      return;
    }

    jjUpdateOperatingRail(payload);
    alert('Private profile saved.');
  }

  async function uploadProfilePortrait(file) {
    try {
      const supabase = await jjInitSupabase();
      const user = await jjGetOptionalAuthUser();
      if (!file) return null;

      const ownerId = jjClientOwnerId(user);
      const fileExt = file.name.split('.').pop().toLowerCase();
      const fileName = ownerId + '-portrait-' + Date.now() + '.' + fileExt;
      const filePath = ownerId + '/' + fileName;

      const uploadResult = await supabase.storage
        .from(JJ_PROFILE_BUCKET)
        .upload(filePath, file, { upsert: true });

      if (uploadResult.error) throw uploadResult.error;

      const publicUrl = supabase.storage.from(JJ_PROFILE_BUCKET).getPublicUrl(filePath).data.publicUrl;
      window.JJ_PROFILE_PORTRAIT_URL = publicUrl;

      const preview = byId('jj-profile-portrait-preview');
      if (preview) {
        preview.innerHTML = '<img src="' + jjEscapeHtml(publicUrl) + '" alt="Portrait">';
      }

      jjUpdateOperatingRail();
      return publicUrl;
    } catch (error) {
      console.error('PORTRAIT UPLOAD ERROR:', error);
      alert('Unable to upload portrait.');
      return null;
    }
  }

  function populateProfileForm(profile) {
    if (!profile) return;

    const overview = profile.overview || {};
    const fit = profile.fit_sizes || {};
    const preferences = profile.preferences || {};
    const uploads = profile.uploads || {};

    if (byId('jj-profile-name')) byId('jj-profile-name').value = overview.name || '';
    if (byId('jj-profile-city')) byId('jj-profile-city').value = overview.city || '';
    if (byId('jj-profile-phone')) byId('jj-profile-phone').value = overview.phone || '';
    if (byId('jj-profile-ship')) byId('jj-profile-ship').value = overview.shipping_notes || '';
    if (byId('jj-profile-notes')) byId('jj-profile-notes').value = overview.private_notes || '';

    if (byId('jj-profile-size-top')) byId('jj-profile-size-top').value = fit.top_size || '';
    if (byId('jj-profile-size-bottom')) byId('jj-profile-size-bottom').value = fit.bottom_size || '';
    if (byId('jj-profile-size-dress')) byId('jj-profile-size-dress').value = fit.dress_size || '';
    if (byId('jj-profile-size-shoe')) byId('jj-profile-size-shoe').value = fit.shoe_size || '';
    if (byId('jj-profile-fit')) byId('jj-profile-fit').value = fit.preferred_fit || '';
    if (byId('jj-profile-tailoring')) byId('jj-profile-tailoring').value = fit.tailoring_notes || '';
    if (byId('jj-profile-measurements')) byId('jj-profile-measurements').value = fit.measurements || '';

    if (byId('jj-profile-brands')) byId('jj-profile-brands').value = preferences.brand_preferences || '';
    if (byId('jj-profile-colors')) byId('jj-profile-colors').value = preferences.color_preferences || '';
    if (byId('jj-profile-avoid')) byId('jj-profile-avoid').value = preferences.avoid || '';
    if (byId('jj-profile-priority')) byId('jj-profile-priority').value = preferences.category_priorities || '';
    if (byId('jj-profile-lifestyle')) byId('jj-profile-lifestyle').value = preferences.lifestyle_needs || '';
    if (byId('jj-profile-spend')) byId('jj-profile-spend').value = preferences.spending_posture || '';

    if (uploads.portrait_url) {
      window.JJ_PROFILE_PORTRAIT_URL = uploads.portrait_url;
      const preview = byId('jj-profile-portrait-preview');
      if (preview) {
        preview.innerHTML = '<img src="' + jjEscapeHtml(uploads.portrait_url) + '" alt="Portrait">';
      }
    }

    jjUpdateOperatingRail(profile);
  }

  function initProfileTabs() {
    const modal = byId('jjProfileModal');
    if (!modal) return;

    const tabs = modal.querySelectorAll('.jj-profiletabs__tab');
    const panels = modal.querySelectorAll('.jj-profilepanel');
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const target = tab.getAttribute('data-tab');

        tabs.forEach(function (item) {
          item.classList.remove('is-active');
        });
        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        tab.classList.add('is-active');

        const activePanel = modal.querySelector('.jj-profilepanel[data-panel="' + target + '"]');
        if (activePanel) {
          activePanel.classList.add('is-active');
        }
      });
    });

    const portraitInput = byId('jj-profile-portrait-input') || byId('jj-profile-portrait');
    if (portraitInput) {
      portraitInput.addEventListener('change', async function (e) {
        const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
        if (!file) return;

        await uploadProfilePortrait(file);
        await saveClientProfile();
      });
    }
  }

  /* ===============================
     PRIVACY CONSENT
  ================================ */

  function jjConsentStorageKey(user) {
    const id = user && user.id ? user.id : 'guest';
    return 'jj_private_desk_consent_v1_' + id;
  }

  function jjHasPrivateDeskConsent(user) {
    try {
      return window.localStorage.getItem(jjConsentStorageKey(user)) === 'accepted';
    } catch (error) {
      return false;
    }
  }

  function jjSavePrivateDeskConsent(user) {
    const payload = {
      accepted: true,
      accepted_at: new Date().toISOString(),
      user_id: user && user.id ? user.id : null,
      email: user && user.email ? user.email : null,
      version: '2026-03-24'
    };

    try {
      window.localStorage.setItem(jjConsentStorageKey(user), 'accepted');
      window.localStorage.setItem(jjConsentStorageKey(user) + '_record', JSON.stringify(payload));
    } catch (error) {
      console.warn('Unable to save Private Desk consent locally.', error);
    }
  }

  function jjEnsureConsentModal() {
    let modal = byId('jj-private-consent-modal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'jj-private-consent-modal';
    modal.className = 'jj-private-consent';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
      <div class="jj-private-consent__scrim"></div>
      <div class="jj-private-consent__panel" role="dialog" aria-modal="true" aria-labelledby="jj-private-consent-title">
        <p class="jj-private-consent__eyebrow">Private Desk Access</p>
        <h2 id="jj-private-consent-title">Privacy Policy & Data Consent</h2>
        <p class="jj-private-consent__copy">Before entering the Private Desk, please consent to Jerrimiah James using your wardrobe images, sizing, style preferences, product-page activity, command bar signals, and Private Desk communications to provide personalized styling, sourcing, and wardrobe-governance recommendations.</p>
        <label class="jj-private-consent__check">
          <input type="checkbox" id="jj-private-consent-check">
          <span>I agree to the Privacy Policy & Data Consent and the Terms of Use & Private Desk User Agreement.</span>
        </label>
        <div class="jj-private-consent__links">
          <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy & Data Consent</a>
          <a href="/policies/terms-of-service" target="_blank" rel="noopener">Terms of Use & Private Desk User Agreement</a>
        </div>
        <div class="jj-private-consent__actions">
          <button type="button" class="jj-private-consent__accept" id="jj-private-consent-accept" disabled>Enter Private Desk</button>
          <button type="button" class="jj-private-consent__decline" id="jj-private-consent-decline">Not Now</button>
        </div>
      </div>
    `;

    const style = document.createElement('style');
    style.textContent = `
      .jj-private-consent{position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;padding:22px;color:#f8f3eb;}
      .jj-private-consent.is-open{display:flex;}
      .jj-private-consent__scrim{position:absolute;inset:0;background:rgba(8,8,8,.74);backdrop-filter:blur(16px);}
      .jj-private-consent__panel{position:relative;width:min(620px,100%);background:#1d1918;border:1px solid rgba(232,218,196,.24);box-shadow:0 28px 90px rgba(0,0,0,.38);padding:34px;border-radius:8px;}
      .jj-private-consent__eyebrow{margin:0 0 10px;font-size:11px;letter-spacing:.26em;text-transform:uppercase;color:#caa363;}
      .jj-private-consent h2{margin:0 0 14px;font-size:30px;line-height:1.05;font-family:Georgia,serif;font-weight:400;color:#fffaf2;}
      .jj-private-consent__copy{margin:0 0 18px;font-size:15px;line-height:1.65;color:rgba(255,250,242,.78);}
      .jj-private-consent__check{display:flex;gap:12px;align-items:flex-start;margin:0 0 16px;padding:16px;border:1px solid rgba(232,218,196,.18);background:rgba(255,255,255,.04);border-radius:6px;font-size:14px;line-height:1.55;color:rgba(255,250,242,.88);}
      .jj-private-consent__check input{margin-top:4px;accent-color:#caa363;}
      .jj-private-consent__links{display:flex;gap:18px;margin:0 0 24px;font-size:12px;letter-spacing:.16em;text-transform:uppercase;}
      .jj-private-consent__links a{color:#f1dfbf;text-decoration:underline;text-underline-offset:4px;}
      .jj-private-consent__actions{display:flex;gap:12px;flex-wrap:wrap;}
      .jj-private-consent__actions button{border-radius:999px;padding:13px 20px;font-size:12px;letter-spacing:.16em;text-transform:uppercase;cursor:pointer;}
      .jj-private-consent__accept{border:1px solid #fffaf2;background:#fffaf2;color:#171313;}
      .jj-private-consent__accept:disabled{opacity:.45;cursor:not-allowed;}
      .jj-private-consent__decline{border:1px solid rgba(255,250,242,.28);background:transparent;color:#fffaf2;}
      @media(max-width:640px){.jj-private-consent__panel{padding:24px}.jj-private-consent h2{font-size:25px}}
    `;

    document.head.appendChild(style);
    document.body.appendChild(modal);
    return modal;
  }

  function jjRequirePrivateDeskConsent(user) {
    if (jjHasPrivateDeskConsent(user)) return Promise.resolve(true);

    return new Promise(function (resolve) {
      const modal = jjEnsureConsentModal();
      const checkbox = byId('jj-private-consent-check');
      const accept = byId('jj-private-consent-accept');
      const decline = byId('jj-private-consent-decline');

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('jj-no-scroll');
      document.body.classList.add('jj-no-scroll');

      if (checkbox && accept) {
        checkbox.checked = false;
        accept.disabled = true;
        checkbox.onchange = function () {
          accept.disabled = !checkbox.checked;
        };
      }

      if (accept) {
        accept.onclick = function () {
          if (checkbox && !checkbox.checked) return;
          jjSavePrivateDeskConsent(user);
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('jj-no-scroll');
          document.body.classList.remove('jj-no-scroll');
          resolve(true);
        };
      }

      if (decline) {
        decline.onclick = async function () {
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('jj-no-scroll');
          document.body.classList.remove('jj-no-scroll');
          try {
            const supabase = await jjInitSupabase();
            if (supabase) await supabase.auth.signOut();
          } catch (error) {
            console.warn('Unable to sign out after consent decline.', error);
          }
          window.location.href = '/';
        };
      }
    });
  }

  /* ===============================
     AUTH FLOW
  ================================ */

  async function checkAccessFlow() {
    const authGate = byId('jjAuthGate');

    if (authGate) {
      authGate.remove();
    }

    const user = await jjGetOptionalAuthUser();
    await jjRequirePrivateDeskConsent(user || jjConsentClient());
    return true;
  }

  function bindAuthButton() {
    const tryBind = function () {
      const btn = byId('jjAuthSendLink');
      if (!btn) {
        setTimeout(tryBind, 300);
        return;
      }

      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';

      btn.addEventListener('click', async function () {
        const emailInput = byId('jjAuthEmail');
        const status = byId('jjAuthStatus');
        const email = emailInput && emailInput.value ? emailInput.value.trim() : '';

        if (!email) {
          if (status) status.textContent = 'Enter your email.';
          return;
        }

        try {
          const supabase = await jjInitSupabase();
          if (status) status.textContent = 'Sending secure access link...';
          btn.disabled = true;

          const result = await supabase.auth.signInWithOtp({
            email: email,
            options: {
              emailRedirectTo: window.location.origin + '/pages/private-desk'
            }
          });

          if (result.error) throw result.error;
          if (status) status.textContent = 'Check your email for your secure access link.';
        } catch (err) {
          console.error('AUTH ERROR:', err);
          if (status) status.textContent = err.message || 'Unable to send link.';
        }

        setTimeout(function () {
          btn.disabled = false;
        }, 4000);
      });
    };

    tryBind();
  }

  document.addEventListener('DOMContentLoaded', async function () {
    initPrivateDeskSectionOrder();
    initRevealAnimation();
    initAppointmentFormBodyBuilder();
    initPrivateDeskUiRefinements();
    initPrivateDeskServiceRequests();
    initVerdictEngine();
    initAuthorityRead();
    initClosetUploadHandler();
    initPrivateDeskSignalRoom();
    initMirrorControls();
    initProfileTabs();

    setTimeout(function () {
      const tier = client.membershipTier
        ? client.membershipTier.replace('jj_', '').trim().toLowerCase()
        : null;

      if (!jjHasPrivateDeskMembership()) {
        blockSection('#jj-authority-read');
        blockSection('#jj-dressing-room');
        blockSection('#jj-verdictengine');
        return;
      }

      gateSection('#jj-authority-read', 'preview');
      gateSection('#jj-dressing-room', 'preview');
      gateSection('#jj-verdictengine', 'preview');
    }, 400);

    const profileForm = byId('jjProfileForm');
    if (profileForm) {
      profileForm.addEventListener('submit', function (event) {
        event.preventDefault();
        saveClientProfile();
      });
    }

    const profileSaveBtn = byId('jj-profile-save');
    if (profileSaveBtn) {
      profileSaveBtn.addEventListener('click', function () {
        saveClientProfile();
      });
    }

    try {
      const existingProfile = await loadClientProfile();
      if (existingProfile) {
        populateProfileForm(existingProfile);
      }
    } catch (error) {
      console.error('PROFILE INIT ERROR:', error);
    }

    const supabase = await jjInitSupabase();

    const canEnterPrivateDesk = await checkAccessFlow();
    if (!canEnterPrivateDesk) return;

    if (supabase && supabase.auth && supabase.auth.onAuthStateChange) {
      supabase.auth.onAuthStateChange(async function () {
        const canEnter = await checkAccessFlow();
        if (!canEnter) return;
        if (byId('jj-droom-garments')) {
          await loadClosetItems();
        }
      });
    }

    if (byId('jj-droom-garments')) {
      await loadClosetItems();
    }
  });

  window.uploadClosetItem = uploadClosetItem;
  window.JJPrivateDeskRail = {
    refresh: jjUpdateOperatingRail
  };
  window.detectPieceType = detectPieceType;
  window.runAuthorityRead = runAuthorityRead;
})();
